<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<!-- eslint-disable vue/no-parsing-error -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main v-if="reservation != null" class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('pageRoomReservation.title.reservation') }} #{{ reservation.reservationNumber }}
    </portal>
    <card :title="$t('pageRoomReservation.card.reservationDetails')" cols="12 6@tablet 4@desktop 3@hd" rows="1 4@desktop">
      <template slot="header-right">
        {{ $t('pageRoomReservation.card.reservationNumber') }}{{ reservation.reservationNumber }}
      </template>
      <hm-card-inner v-if="reservation.managedBy !== 'Hotelmeister'">
        <hm-col cols="12">
          <div style="position:relative; margin-bottom: 0.8rem;">{{ $t('pageRoomReservation.hintManagedByChannelManager') }}</div>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner>
        <hm-input v-if="reservation.managedBy !== 'Hotelmeister'"
                  :disabled="true"
                  :label="$t('pageRoomReservation.managedBy')"
                  value="Channel-Manager"
                  name="managedBy">
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-tooltip="{ title: $t('pageRoomReservation.retrieveReservation'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                               v-if="hasRole('ROLE_SYSADMIN') && ['ConnectCX','HotelSpider'].includes(reservation.managedBy) && !['RequestExpired','CreationFailed','Departed'].includes(reservation.status)"
                               :border="true"
                               :disabled="false"
                               icon="download"
                               @click="retrieveReservation(reservation.managedBy, reservation)" />
          </template>
        </hm-input>
        <hm-input v-if="!isEmpty(reservation.sourceInfo.sourceName)"
                  v-model="reservation.sourceInfo.sourceName"
                  :disabled="true"
                  :label="$t('pageRoomReservation.reservationSourceName')"
                  class="privacy--blur"
                  name="reservationSourceName" />
        <hm-input v-if="isEmpty(reservation.sourceInfo.sourceName)"
                  :disabled="true"
                  :label="$t('pageRoomReservation.reservationSourceName')"
                  :value="hotelSettings.hotel.whiteLabel"
                  class="privacy--blur"
                  name="reservationSourceName"
                  hidden="mobile" />
        <template v-for="externalReservationNumber in reservation.externalReservationNumbers">
          <hm-input v-model="externalReservationNumber.value"
                    :disabled="true"
                    :key="`${externalReservationNumber.key}::${externalReservationNumber.value}`"
                    :label="externalReservationNumber.key"
                    name="externalReservationNumber" />
        </template>
        <template v-if="!isEmpty(reservation.confirmationNumber)">
          <hm-input-link v-if="confirmationNumberLocked || isEmpty(reservationGroups)"
                         id="confirmation-number"
                         v-model="reservation.confirmationNumber"
                         :route="{ name: 'reservationGroup', params: { confirmationNumberOrReservationGroupId: reservation.confirmationNumber } }"
                         :label="$t('pageRoomReservation.confirmationNumber')"
                         :help="$t('pageRoomReservation.confirmationNumber_help')"
                         name="confirmationNumber">
            <template slot="icon-inline-right" slot-scope="slot">
              <input-icon-button v-tooltip="{ title: $t('pageRoomReservation.unlockConfirmationNumber'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                                 v-if="reservation.managedBy === 'Hotelmeister' && (reservation.status === 'Guaranteed' || reservation.status === 'NonGuaranteed' || reservation.status === 'AwaitingPayment')"
                                 :border="true"
                                 :disabled="false"
                                 icon="unlock"
                                 @click="unlockConfirmationNumber" />
            </template>
          </hm-input-link>
          <hm-input-select v-tooltip="{ title: $t('pageRoomReservation.lockConfirmationNumber'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                           v-else
                           v-model="reservation.confirmationNumber"
                           :label="$t('pageRoomReservation.confirmationNumber')"
                           :help="$t('pageRoomReservation.confirmationNumber_help')"
                           name="confirmationNumber">
            <option v-for="item in reservationGroups" :value="item.confirmationNumber" v-html="`${item.confirmationNumber} / ${item.name || '-'}`"></option>
            <template v-for="item in reservation.externalReservationNumbers">
              <option v-if="item.key === 'OldConfirmationNumber'" :value="item.value" v-html="`${item.value} / Vorherige Bestätigungsnummer`"></option>
            </template>
            <template slot="icon-inline-right" slot-scope="slot">
              <input-icon-button :border="true" :disabled="false" icon="lock" @click="confirmationNumberLocked = true" />
            </template>
          </hm-input-select>
        </template>
        <hm-input :value="$t(`ReservationStatus.${reservation.status}`)" :disabled="true" :label="$t('pageRoomReservation.reservationStatus')" name="reservationStatus" />
        <hm-input-date v-model="reservation.checkInDate"
                       :max-date="maxArrivalDate"
                       :disabled="!canEdit || isLocked || reservation.status == 'InHouse' || reservation.status == 'Departed'"
                       :label="$t('pageRoomReservation.arrivalDate')"
                       :context-help="$t('pageRoomReservation.arrivalDate_contextHelp')"
                       cols="6"
                       name="arrivalDate" />
        <hm-input-date v-model="reservation.checkOutDate"
                       :max-date="maxDepartureDate"
                       :min-date="reservation.checkInDate"
                       :disabled="!canEdit || isLocked || reservation.status == 'Departed'"
                       :label="$t('pageRoomReservation.departureDate')"
                       :context-help="$t('pageRoomReservation.departureDate_contextHelp')"
                       cols="6"
                       name="departureDate" />
        <hm-input-select v-model="reservation.stayDetails.roomTypeId" :disabled="!canEdit || isLocked" :label="$t('pageRoomReservation.roomType')" name="roomType">
          <option v-for="item in hotelSettings.roomTypes.all(reservation.stayDetails.roomTypeId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
        </hm-input-select>
        <hm-input-select v-model="reservation.stayDetails.ratePlanId" :disabled="!canEdit || isLocked" :label="$t('pageRoomReservation.rate')" name="rate">
          <option v-for="item in hotelSettings.ratePlans.all(reservation.stayDetails.ratePlanId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
        </hm-input-select>
        <hm-input-select v-model="reservation.stayDetails.roomNumber"
                         :label="$t('pageRoomReservation.roomNumber')"
                         :help="$t('pageRoomReservation.roomNumber_help')"
                         :disabled="!canEdit"
                         name="roomNumber">
          <option :value="null"></option>
          <option v-for="item in hotelSettings.rooms.all(reservation.stayDetails.roomNumber)" :value="item.roomNumber" v-html="`${item.roomNumber} (${item.roomType.name[$shortLocale]}) ${unavailableRooms.includes(item.roomNumber) ? 'BELEGT' : ''}`"></option>
        </hm-input-select>
        <hm-input-toggle id="room-number-locked"
                         v-model="reservation.stayDetails.roomNumberLocked"
                         :label="$t('pageRoomReservation.roomNumberLocked')"
                         :enabled-title="$t('pageRoomReservation.roomNumberLockedEnabled')"
                         :disabled-title="$t('pageRoomReservation.roomNumberLockedDisabled')"
                         :disabled="!canEdit"
                         name="roomNumberLocked"
                         hidden="mobile" />
        <hm-input-select v-model="reservation.type"
                         :label="$t('pageRoomReservation.reservationType')"
                         :disabled="!canEdit"
                         name="reservationType"
                         enum-name="ReservationType" />
        <hm-input-date v-if="reservation.type === 'OnRequest'"
                       v-model="reservation.requestExpirationDate"
                       :required="false"
                       :disabled="!canEdit"
                       :label="$t('pageRoomReservation.requestExpirationDate')"
                       :help="$t('pageRoomReservation.requestExpirationDate_help')"
                       :context-help="$t('pageRoomReservation.requestExpirationDate_contextHelp')"
                       name="requestExpirationDate" />
        <hm-reservation-color-picker v-model="reservation.colorCategoryCssClass"
                                     :label="$t('pageRoomReservation.colorCategoryCssClass ')"
                                     :disabled="!canEdit"
                                     name="colorCategoryCssClass "
                                     hidden="mobile" />
        <hm-multiselect v-if="hotelSettings.details.additionalFields.ROOMPLAN_RESERVATION_ICONS"
                        id="icons"
                        v-model="reservation.additionalFields.HMC_ROOMPLAN_ICONS"
                        :options="icons"
                        :label="$t('pageRoomReservation.roomPlanIcons')"
                        :clearable="true"
                        :disabled="!canEdit"
                        :label-expression="(args) => this.$t(`pageRoomReservation.icon.${args.option.name}`)"
                        value-expression="name"
                        name="icons">
          <template slot="option" slot-scope="props">
            <table>
              <tr>
                <td style="width:3rem;"><i :class="`fas fa-${props.option.name}`"></i></td>
                <td>{{ $t(`pageRoomReservation.icon.${props.option.name}`) }}</td>
              </tr>
            </table>
          </template>
        </hm-multiselect>
        <!-- shortInternalComment: has to be lazy because it can be modified by the script -->
        <hm-input v-model="reservation.shortInternalComment"
                  :maxlength="5"
                  :lazy="true"
                  :label="$t('pageRoomReservation.shortInternalComment')"
                  :help="$t('pageRoomReservation.shortInternalComment_help')"
                  :context-help="$t('pageRoomReservation.shortInternalComment_contextHelp')"
                  :disabled="!canEdit"
                  name="shortInternalComment"
                  hidden="mobile" />
        <hm-input-select v-model="reservation.travelPurpose"
                         :label="$t('pageRoomReservation.travelPurpose')"
                         :disabled="!canEdit"
                         name="travelPurpose"
                         enum-name="TravelPurpose"
                         hidden="mobile" />
        <hm-button v-if="!isEmpty(reservation.additionalFields) && !isEmpty(reservation.additionalFields.OFFER_ID)"
                   class="btn--green btn--no-margin"
                   cols="12"
                   icon-left="eye"
                   @click="$router.push({ name: 'offer', params: { guestOfferId: reservation.additionalFields.OFFER_ID } })">{{ $t('pageRoomReservation.actionOpenOffer') }}</hm-button>
        <hm-button v-if="!isEmpty(reservation.additionalFields) && !isEmpty(reservation.additionalFields.STRIPE_CUSTOMER_TOKEN)"
                   class="btn--blue btn--no-margin"
                   cols="12"
                   icon-left="credit-card"
                   @click="openStripeCustomer(reservation.additionalFields.STRIPE_CUSTOMER_TOKEN)">{{ $t('pageRoomReservation.actionOpenStripe') }}</hm-button>
      </hm-card-inner>
      <hm-card-inner :title="$t('pageRoomReservation.card.checkInCheckOutTimes')">
        <hm-input-toggle :value="!isNil(reservation.stayDetails.arrivalTime)"
                         :label="$t('pageRoomReservation.deviatingArrivalTime')"
                         cols="12 7@desktop"
                         @input="(value) => value === true ? reservation.stayDetails.arrivalTime = hotelSettings.details.checkInTime : reservation.stayDetails.arrivalTime = null" />
        <hm-input-time-of-day-slider v-if="isNil(reservation.stayDetails.arrivalTime)"
                                     :value="hotelSettings.details.checkInTime"
                                     :disabled="true"
                                     :step="0.25"
                                     :default-value="hotelSettings.details.checkInTime"
                                     :label="$t('pageRoomReservation.arrivalTime')"
                                     cols="12 5@desktop"
                                     fa-icon="fak fa-thin-person-walking-luggage-clock fa-lg"
                                     name="arrivalTime" />
        <hm-input-time-of-day-slider v-else
                                     v-model="reservation.stayDetails.arrivalTime"
                                     :step="0.25"
                                     :default-value="hotelSettings.details.checkInTime"
                                     :label="$t('pageRoomReservation.arrivalTime')"
                                     cols="12 5@desktop"
                                     fa-icon="fak fa-thin-person-walking-luggage-clock fa-lg"
                                     name="arrivalTime" />

        <hm-input-toggle :value="!isNil(reservation.stayDetails.departureTime)"
                         :label="$t('pageRoomReservation.deviatingDepartureTime')"
                         cols="12 7@desktop"
                         @input="(value) => value === true ? reservation.stayDetails.departureTime = hotelSettings.details.checkOutTime : reservation.stayDetails.departureTime = null" />
        <hm-input-time-of-day-slider v-if="isNil(reservation.stayDetails.departureTime)"
                                     :value="hotelSettings.details.checkOutTime"
                                     :disabled="true"
                                     :step="0.25"
                                     :default-value="hotelSettings.details.checkOutTime"
                                     :label="$t('pageRoomReservation.departureTime')"
                                     cols="12 5@desktop"
                                     fa-icon="fak fa-thin-person-walking-luggage-clock fa-flip-horizontal fa-lg"
                                     name="departureTime" />
        <hm-input-time-of-day-slider v-else
                                     v-model="reservation.stayDetails.departureTime"
                                     :step="0.25"
                                     :default-value="hotelSettings.details.checkOutTime"
                                     :label="$t('pageRoomReservation.departureTime')"
                                     cols="12 5@desktop"
                                     fa-icon="fak fa-thin-person-walking-luggage-clock fa-flip-horizontal fa-lg"
                                     name="departureTime" />
      </hm-card-inner>
    </card>

    <tabable-card id="guests" :active-card="activeGuestCard" cols="12 6@tablet 4@desktop 3@hd" rows="1 2@desktop">
      <tabable-card-content :title="$t('pageRoomReservation.card.guest')" :indicator="isEmpty(reservation.stayDetails.primaryGuestProfileId) ? null : 'green'">
        <guest-profile-editor id="guest"
                              v-model="reservation.stayDetails.primaryGuestProfileId"
                              :search-disabled="!canEdit"
                              :disabled="!canEditGuest"
                              type="Guest">
          <template slot="default" slot-scope="props">
            <template v-if="!isNil(reservation.stayDetails.primaryGuestDetail) && (reservation.stayDetails.primaryGuestDetail.staysInRoom === false || (hasLicense('SelfCheckIn') && !isEmpty(reservation.stayDetails.primaryGuestDetail)))">
              <hm-input-toggle v-model="reservation.stayDetails.primaryGuestDetail.staysInRoom"
                               :label="$t('pageRoomReservation.staysInRoom')"
                               :disabled-title="$t('pageRoomReservation.staysInRoomDisabled')"
                               :enabled-title="$t('pageRoomReservation.staysInRoomEnabled')"
                               :disabled="props.disabled"
                               cols="12" />
            </template>
          </template>
        </guest-profile-editor>
      </tabable-card-content>
      <tabable-card-content :title="$t('pageRoomReservation.card.company')" :indicator="isEmpty(reservation.stayDetails.companyProfileId) ? null : 'green'">
        <guest-profile-editor id="company"
                              v-model="reservation.stayDetails.companyProfileId"
                              :search-disabled="!canEdit"
                              :disabled="!canEditGuest"
                              type="Company" />
      </tabable-card-content>
      <tabable-card-content :title="$t('pageRoomReservation.card.travelAgent')" :indicator="isEmpty(reservation.stayDetails.travelAgentProfileId) ? null : 'green'">
        <guest-profile-editor id="travelagent"
                              v-model="reservation.stayDetails.travelAgentProfileId"
                              :search-disabled="!canEdit"
                              :disabled="!canEditGuest"
                              type="TravelAgent" />
      </tabable-card-content>
      <tabable-card-content :title="$t('pageRoomReservation.card.billingContact')" :indicator="isEmpty(reservation.stayDetails.billingContactProfileId) ? null : 'green'">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <span class="info-text info-text--full-size info-text--no-margin col-12">{{ $t('pageRoomReservation.infoTextBillingContact') }}</span>
          </hm-col>
        </hm-card-inner>
        <guest-profile-editor id="billingContact"
                              v-model="reservation.stayDetails.billingContactProfileId"
                              :search-disabled="!canEdit"
                              :disabled="!canEditGuest"
                              type="Company" />
      </tabable-card-content>
    </tabable-card>

    <tabable-card id="additional-guests"
                  ref="additionalGuestsTabableCardContainer"
                  :active-card="additionalGuestsActiveCard"
                  :watch-active-card="true"
                  cols="12 6@tablet 4@desktop 3@hd"
                  rows="1@hd">
      <tabable-card-content v-if="hasLicense('InterfaceMeldeblatt')"
                            :title="$t('pageRoomReservation.card.meldeblaetter')"
                            :center="!warningMeldeblattNotArrived && !warningMeldeblattDoesNotExist && isEmpty(meldeblaetter)">
        <spinner-overlay v-if="loadedPage.meldeblatt === false" />
        <hm-col v-if="warningMeldeblattNotArrived" cols="12">
          <span class="warning-text col-12" v-html="$t('pageRoomReservation.confirmReservationInHouseMeldeblattNotArrived')"></span>
        </hm-col>
        <hm-col v-if="warningMeldeblattDoesNotExist" cols="12">
          <span class="warning-text col-12" v-html="$t('pageRoomReservation.confirmReservationInHouseMeldeblaetterDoesNotExist')"></span>
        </hm-col>
        <hm-col :key="meldeblattKey" cols="12">
          <hm-card-inner v-if="isEmpty(meldeblaetter)">
            <card-action :title="$t('pageRoomReservation.cardActionCreateMeldeblatt')" @click="createMeldeblatt(false)" />
          </hm-card-inner>
          <hm-card-inner v-else :full-size="true">
            <hm-table :hover="true" columns="5" min-width="450px">
              <template slot="table-head">
                <div class="hm-table__th">{{ $t('pageRoomReservation.meldeblaetter.meldeblattNumber') }}</div>
                <div class="hm-table__th">{{ $t('pageRoomReservation.meldeblaetter.arrivalDate') }}</div>
                <div class="hm-table__th">{{ $t('pageRoomReservation.meldeblaetter.departureDate') }}</div>
                <div class="hm-table__th">{{ $t('pageRoomReservation.meldeblaetter.numPersons') }}</div>
                <div class="hm-table__th">{{ $t('pageRoomReservation.meldeblaetter.status') }}</div>
              </template>
              <template slot="default">
                <template v-for="row in meldeblaetter">
                  <template v-if="row.status !== 'Deleted' || hasRole('ROLE_SYSADMIN')">
                    <div class="hm-table__td" @click="openMeldeblatt(row.id)">{{ row.meldeblattNummer <= 0 ? '-' : row.meldeblattNummer }}</div>
                    <div class="hm-table__td" @click="openMeldeblatt(row.id)">{{ row.anreise | toDate }}</div>
                    <div class="hm-table__td" @click="openMeldeblatt(row.id)">{{ row.abreise | toDate }}</div>
                    <div class="hm-table__td" @click="openMeldeblatt(row.id)">{{ row.guestCount }}</div>
                    <div v-if="row.anreise === row.abreise" class="hm-table__td" @click="openMeldeblatt(row.id)">{{ $t('MeldeStatus.Cancelled') }}</div>
                    <div v-else class="hm-table__td" @click="openMeldeblatt(row.id)">
                      <template v-if="row.status === 'Draft'">
                        <template v-if="['Complete', 'CompleteSigned'].includes(row.validationStatus)">
                          {{ $t(`MeldeblattValidationStatus.${row.validationStatus}`) }}
                        </template>
                        <template v-else>
                          {{ $t(`MeldeStatus.${row.status}`) }}
                        </template>
                      </template>
                      <template v-else>
                        {{ $t(`MeldeStatus.${row.status}`) }}
                      </template>
                    </div>
                  </template>
                </template>
              </template>
            </hm-table>
          </hm-card-inner>
        </hm-col>
      </tabable-card-content>
      <tabable-card-content :center="isEmpty(reservation.stayDetails.additionalGuests)"
                            :title="$t('pageRoomReservation.card.additionalGuests')"
                            :indicator="isEmpty(reservation.stayDetails.additionalGuests) ? null : 'green'">
        <hm-col :grid="true" cols="12">
          <hm-card-inner v-if="isEmpty(reservation.stayDetails.additionalGuests)">
            <card-action :title="$t('pageRoomReservation.cardActionAddAdditionalGuests')" @click="addAdditionalGuest(null)" />
          </hm-card-inner>
          <template v-for="(guest, index) in reservation.stayDetails.additionalGuests">
            <hm-card-inner :title="$t('pageRoomReservation.card.additionalGuest', { idx: index+1})" :deletable="true" :key="guest.id" @delete="deleteGuestDetail(guest)">
              <hm-input v-model="guest.firstName"
                        :disabled="!canEdit || !isEmpty(guest.guestProfileId)"
                        :label="$t('pageRoomReservation.firstName')"
                        :lazy="true"
                        class="privacy--blur"
                        name="firstName"
                        cols="12 4@tablet" />
              <hm-input v-model="guest.lastName"
                        :disabled="!canEdit || !isEmpty(guest.guestProfileId)"
                        :label="$t('pageRoomReservation.lastName')"
                        :lazy="true"
                        class="privacy--blur"
                        name="lastName"
                        cols="12 4@tablet" />
              <hm-input-date :required="false"
                             v-model="guest.dateOfBirth"
                             :disabled="!canEdit || !isEmpty(guest.guestProfileId)"
                             :label="$t('pageRoomReservation.dateOfBirth')"
                             :lazy="true"
                             name="dateOfBirth"
                             cols="12 4@tablet" />
            </hm-card-inner>
          </template>
        </hm-col>
      </tabable-card-content>
      <tabable-card-content :display="!isEmpty(fellowTravellers)" :title="$t('pageRoomReservation.card.fellowTravellersPreviousStays')">
        <spinner-overlay v-if="loadedPage.fellowTravellers === false" />
        <hm-card-inner>
          <hm-col cols="12">
            <p class="explanation-text">{{ $t('pageRoomReservation.hintFellowTravellersPreviousStays') }}</p>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner v-if="!isEmpty(fellowTravellers)" :full-size="true">
          <hm-table :hover="false" columns="4" min-width="450px">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('pageRoomReservation.fellowTravellers.name') }}</div>
              <div class="hm-table__th">{{ $t('pageRoomReservation.fellowTravellers.dateOfBirth') }}</div>
              <div class="hm-table__th">{{ $t('pageRoomReservation.fellowTravellers.age') }}</div>
              <div class="hm-table__th"></div>
            </template>
            <template slot="default">
              <template v-for="row in fellowTravellers">
                <div class="hm-table__td privacy--blur">{{ row.displayName }}</div>
                <div class="hm-table__td">{{ row.dateOfBirth | toDate }}</div>
                <div class="hm-table__td">{{ row.dateOfBirth | toAge }}</div>
                <div class="hm-table__td hm-table__td--icon" @click="addAdditionalGuest(row.guestDetail)">
                  <span v-if="canEdit && !additionalGuestIds.includes(row.guestDetail.id)" class="quick-action-button">
                    <icon icon="plus" />
                  </span>
                </div>
              </template>
            </template>
          </hm-table>
        </hm-card-inner>
      </tabable-card-content>
    </tabable-card>

    <card :title="$t('pageRoomReservation.card.remarks')" cols="12 6@tablet 4@desktop 3@hd">
      <hm-card-inner>
        <!-- guestComment: has to be lazy because it can be modified by the script -->
        <hm-textarea :lazy="true"
                     v-model="reservation.stayDetails.guestComment"
                     :disabled="!canEdit || isLocked"
                     :label="$t('pageRoomReservation.guestComment')"
                     :context-help="$t('pageRoomReservation.guestComment_help')"
                     name="guestComment" />
        <!-- internalComment: has to be lazy because it can be modified by the script -->
        <hm-textarea :lazy="true"
                     v-model="reservation.stayDetails.internalComment"
                     :label="$t('pageRoomReservation.internalComment')"
                     :disabled="!canEdit"
                     name="internalComment" />
      </hm-card-inner>
    </card>

    <card :title="$t('pageRoomReservation.card.onlineCheckIn')" cols="12 6@tablet 4@desktop 3@hd">
      <hm-card-inner v-if="isEmpty(reservation.stayDetails.otaPaymentDetails)">
        <quote :cite="env('WHITE_LABEL_NAME')" text="Coming soon ..." />
      </hm-card-inner>
      <!--      <hm-card-inner v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">-->
      <!--        <hm-input-toggle v-if="!isNil(reservation.stayDetails.eligibleForOnlineCheckIn)"-->
      <!--                         v-model="reservation.stayDetails.eligibleForOnlineCheckIn"-->
      <!--                         :label="$t('pageRoomReservation.eligibleForOnlineCheckIn')"-->
      <!--                         disabled-->
      <!--                         name="onlineCheckIn" />-->
      <!--        <hm-input-money v-if="reservation.stayDetails.onlineCheckIn"-->
      <!--                        :value="reservation.stayDetails.estimatedOnlineCheckInPaymentAmount"-->
      <!--                        :currency="hotelSettings.details.currency"-->
      <!--                        :label="$t('pageRoomReservation.estimatedOnlineCheckInPaymentAmount')"-->
      <!--                        disabled-->
      <!--                        name="estimatedOnlineCheckInPaymentAmount" />-->
      <!--      </hm-card-inner>-->
      <hm-card-inner v-if="!isEmpty(reservation.stayDetails.otaPaymentDetails)" :title="$t('pageRoomReservation.card.otaPaymentDetails')">
        <hm-input :value="$t(`PaymentCollect.${reservation.stayDetails.otaPaymentDetails.paymentCollect || 'Undefined'}`)"
                  :label="$t('pageRoomReservation.paymentCollect')"
                  disabled
                  name="paymentCollect" />
        <hm-input :value="$t(`PaymentType.${reservation.stayDetails.otaPaymentDetails.paymentType || 'Undefined'}`)"
                  :label="$t('pageRoomReservation.paymentType')"
                  disabled
                  name="paymentType" />
        <hm-input-money v-if="!isNil(reservation.stayDetails.otaPaymentDetails.virtualCreditCardBalance) && reservation.stayDetails.otaPaymentDetails.virtualCreditCardBalance > 0"
                        :value="reservation.stayDetails.otaPaymentDetails.virtualCreditCardBalance"
                        :currency="hotelSettings.details.currency"
                        :label="['BankTransfer'].includes(reservation.stayDetails.otaPaymentDetails.paymentType) ? $t('pageRoomReservation.otaPayoutAmount') : $t('pageRoomReservation.initialVirtualCreditCardBalance')"
                        disabled
                        name="virtualCreditCardBalance" />
        <hm-input-money v-if="!isNil(reservation.stayDetails.otaPaymentDetails.otaAmount) && reservation.stayDetails.otaPaymentDetails.otaAmount > 0"
                        :value="reservation.stayDetails.otaPaymentDetails.otaAmount"
                        :currency="hotelSettings.details.currency"
                        :label="$t('pageRoomReservation.otaAmount')"
                        disabled
                        name="otaAmount" />
        <!--        <hm-input-money v-if="!isNil(reservation.stayDetails.otaPaymentDetails.otaAmountIncludingTaxesAndFees) && reservation.stayDetails.otaPaymentDetails.otaAmountIncludingTaxesAndFees > 0"-->
        <!--                        :value="reservation.stayDetails.otaPaymentDetails.otaAmountIncludingTaxesAndFees"-->
        <!--                        :currency="hotelSettings.details.currency"-->
        <!--                        :label="$t('pageRoomReservation.otaAmountIncludingTaxesAndFees')"-->
        <!--                        disabled-->
        <!--                        name="otaAmountIncludingTaxesAndFees" />-->
        <hm-input-date v-if="!isNil(reservation.stayDetails.otaPaymentDetails.virtualCreditCardEffectiveDate)"
                       :value="reservation.stayDetails.otaPaymentDetails.virtualCreditCardEffectiveDate"
                       :label="$t('pageRoomReservation.virtualCreditCardEffectiveDate')"
                       disabled
                       name="virtualCreditCardEffectiveDate" />
        <hm-input-date v-if="!isNil(reservation.stayDetails.otaPaymentDetails.virtualCreditCardExpirationDate)"
                       :value="reservation.stayDetails.otaPaymentDetails.virtualCreditCardExpirationDate"
                       :label="$t('pageRoomReservation.virtualCreditCardExpirationDate')"
                       disabled
                       name="virtualCreditCardExpirationDate" />
        <hm-input v-if="!isEmpty(reservation.stayDetails.otaPaymentDetails.specialCases)"
                  :value="reservation.stayDetails.otaPaymentDetails.specialCases.map(it => $t(`OtaPaymentSpecialCase.${it}`)).join(', ')"
                  :label="$t('pageRoomReservation.otaPaymentSpecialCases')"
                  disabled
                  name="otaPaymentSpecialCases" />
      </hm-card-inner>
    </card>

    <card v-if="hasAnyLicense(['LockingSystems'])"
          :title="$t('pageRoomReservation.card.locking')"
          cols="12 4@desktop 3@hd start-4@hd"
          rows="2 start-3@hd"
          min-height="25rem">
      <template slot="header-button">
        <span class="card__btn card__btn__generic" @click="updateKeys">
          <icon icon="refresh" />
        </span>
      </template>
      <spinner-overlay v-if="updatingKeys" />
      <hm-card-inner v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')">
        <hm-input-toggle v-model="debugKeys" label="Debug Keys? 🔒" />
      </hm-card-inner>
      <template v-if="isEmpty(reservation.stayDetails.roomKeys)">
        <hm-card-inner v-if="canIssueKeyCard">
          <card-action :title="$t('pageRoomReservation.actions.issueKeyCard')" @click="addKeyCard()" />
        </hm-card-inner>
        <hm-card-inner v-if="canIssueKeyCode">
          <card-action :title="$t('pageRoomReservation.actions.issueKeyCode')" @click="addKey()" />
        </hm-card-inner>
      </template>
      <hm-card-inner v-for="key in reservation.stayDetails.roomKeys"
                     :class="[{'card__inner--strike-through-title': key.revoked}]"
                     :key="key.id"
                     :title="getKeyTitle(key)"
                     :title-clickable="!isEmpty(key.additionalFields) && !isEmpty(key.additionalFields.SEAM_DEVICE_ID)"
                     :deletable="!key.revoked"
                     @clickTitle="onClickKey(key)"
                     @delete="revokeKey(key.id)">
        <template v-if="!isEmpty(hotelSettings.interfaces.hotelKeyManagementConfiguration) && !isEmpty(hotelSettings.interfaces.hotelKeyManagementConfiguration[key.keyManagementConfigurationId])">
          <template v-if="!key.revoked || debugKeys">
            <template v-if="['CharPmsLink'].includes(hotelSettings.interfaces.hotelKeyManagementConfiguration[key.keyManagementConfigurationId].lockingSystem)">
              <hm-input v-if="!isNil(key.validityStart)" :value="(key.validityStart * 1000) | toDateTime" :label="$t('pageRoomReservation.locking.validFrom')" disabled />
              <hm-input v-if="!isNil(key.validityEnd)" :value="(key.validityEnd * 1000) | toDateTime" :label="$t('pageRoomReservation.locking.validUntil')" disabled />
              <template v-if="!isEmpty(key.additionalFields)">
                <hm-input v-if="debugKeys && !isEmpty(key.additionalFields.CARDS)" :value="key.additionalFields.CARDS" :label="$t('pageRoomReservation.locking.cardCount')" disabled />
                <hm-input v-if="debugKeys && !isEmpty(key.additionalFields.EXTRA_ACCESS)" :value="key.additionalFields.EXTRA_ACCESS" :label="$t('pageRoomReservation.locking.extraAccess')" disabled />
                <hm-input v-if="debugKeys && !isEmpty(key.additionalFields.ISSUED_AT)" :value="$moment.utc(key.additionalFields.ISSUED_AT, 'YYYYMMDDHHmmss').toISOString() | toLocalDateTime" label="Issued at" disabled />
                <hm-input v-if="debugKeys && !isEmpty(key.additionalFields.ISSUED_BY)" :value="key.additionalFields.ISSUED_BY" label="Issued by" disabled />
                <hm-input v-if="debugKeys && !isEmpty(key.additionalFields.REVOKED_AT)" :value="$moment.utc(key.additionalFields.REVOKED_AT, 'YYYYMMDDHHmmss').toISOString() | toLocalDateTime" label="Revoked at" disabled />
                <hm-input v-if="debugKeys && !isEmpty(key.additionalFields.REVOKED_BY)" :value="key.additionalFields.REVOKED_BY" label="Revoked by" disabled />
              </template>
            </template>
            <template v-else-if="['LoxoneNfcCodeTouch', 'SeamLocks'].includes(hotelSettings.interfaces.hotelKeyManagementConfiguration[key.keyManagementConfigurationId].lockingSystem)">
              <template v-if="debugKeys">
                <hm-input v-if="!isEmpty(key.id)" :value="key.id" label="ID" disabled />
                <hm-input :value="hotelSettings.interfaces.hotelKeyManagementConfiguration[key.keyManagementConfigurationId].lockingSystem" label="Locking System" disabled />
                <hm-input v-if="!isEmpty(key.externalId)" :value="key.externalId" label="External ID" disabled />
                <hm-input v-if="!isEmpty(key.name)" :value="key.name" label="Name" disabled />
                <hm-input-toggle :value="!key.revoked" label="Active?" disabled />
              </template>
              <hm-input v-if="!isNil(key.validityStart)" :value="(key.validityStart * 1000) | toDateTime" :label="$t('pageRoomReservation.locking.validFrom')" disabled />
              <hm-input v-if="!isNil(key.validityEnd)" :value="(key.validityEnd * 1000) | toDateTime" :label="$t('pageRoomReservation.locking.validUntil')" disabled />
            </template>
            <template v-else-if="['SeamLocksAcs'].includes(hotelSettings.interfaces.hotelKeyManagementConfiguration[key.keyManagementConfigurationId].lockingSystem)">
              <template v-if="debugKeys">
                <hm-input v-if="!isEmpty(key.id)" :value="key.id" label="ID" disabled />
                <hm-input :value="hotelSettings.interfaces.hotelKeyManagementConfiguration[key.keyManagementConfigurationId].lockingSystem" label="Locking System" disabled />
                <hm-input v-if="!isEmpty(key.externalId)" :value="key.externalId" label="External ID" disabled />
                <hm-input v-if="!isEmpty(key.name)" :value="key.name" label="Name" disabled />
                <hm-input-toggle :value="!key.revoked" label="Active?" disabled />
                <hm-input v-if="!isEmpty(key.additionalFields.SEAM_USER_EMAIL)" :value="key.additionalFields.SEAM_USER_EMAIL" label="SEAM_USER_EMAIL" disabled />
                <hm-input v-if="!isEmpty(key.additionalFields.SEAM_KEY_TYPE)" :value="key.additionalFields.SEAM_KEY_TYPE" label="SEAM_KEY_TYPE" disabled />
              </template>
              <hm-input v-if="!isEmpty(key.additionalFields.SEAM_INSTANT_KEY_URL)" :value="key.additionalFields.SEAM_INSTANT_KEY_URL" label="URL" disabled>
                <template slot="icon-inline-right" slot-scope="slot">
                  <input-icon-button :border="true" :title="$t('pageMeldeblatt.copyToClipboard')" icon="copy" @click="$copy(key.additionalFields.SEAM_INSTANT_KEY_URL)" />
                </template>
              </hm-input>
              <hm-input v-if="!isNil(key.validityStart)" :value="(key.validityStart * 1000) | toDateTime" :label="$t('pageRoomReservation.locking.validFrom')" disabled />
              <hm-input v-if="!isNil(key.validityEnd)" :value="(key.validityEnd * 1000) | toDateTime" :label="$t('pageRoomReservation.locking.validUntil')" disabled />
            </template>
            <template v-else>
              <hm-input v-if="!isEmpty(key.id)" :value="key.id" label="ID" disabled />
              <!--            <hm-input v-if="!isEmpty(key.code)" :value="key.code" label="Code" disabled />-->
              <!--            <hm-input v-if="!isEmpty(key.externalId)" :value="key.externalId" label="External ID" disabled />-->
            </template>
          </template>
        </template>
      </hm-card-inner>
    </card>

    <tabable-card v-if="hasLicense('Invoicing')" id="payment-status" :active-card="isNil(reservation.stayDetails.roomChargeInvoiceRecipientId) ? 0 : 1" cols="12 6@tablet 4@desktop 3@hd">
      <tabable-card-content v-if="hasLicense('Payments')" :center="false" :title="$t('pageRoomReservation.card.paymentStatusReservation')" @show="updatePaymentCharts()">
        <!--
        <hm-col v-if="guestPaymentStatus.folioWithOpenBalance" cols="12">
          <span class="warning-text col-12">Am Gästeprofil gibt es einen offenen Saldo.</span>
        </hm-col>
        <hm-col v-if="companyPaymentStatus.folioWithOpenBalance" cols="12">
          <span class="warning-text col-12">Am Firmenprofil gibt es einen offenen Saldo.</span>
        </hm-col>
        -->
        <hm-card-inner :title="$t('pageRoomReservation.card.paymentStatusReservation')"
                       :title-clickable="true"
                       @clickTitle="$router.push({ name: 'reservationFolios', params: { reservationId: reservationId }})">
          <spinner-overlay v-if="loadedPage.reservationPaymentStatus === false" />
          <payment-status ref="reservationPaymentStatus" :payment-status="paymentStatus" :route-params="{ reservationId: reservationId}" route="reservationFolios" />
        </hm-card-inner>
        <hm-card-inner v-if="guestPaymentStatus.folioWithOpenBalance || guestPaymentStatus.openFolios"
                       :title="`${$t('pageRoomReservation.card.guest')} #${id2number(reservation.stayDetails.primaryGuestProfileId)}`"
                       :title-clickable="true"
                       @clickTitle="$router.push({ name: 'guestFolios', params: { guestProfileId: reservation.stayDetails.primaryGuestProfileId }})">
          <spinner-overlay v-if="loadedPage.guestPaymentStatus === false" />
          <payment-status ref="guestPaymentStatus" :payment-status="guestPaymentStatus" :route-params="{ guestProfileId: reservation.stayDetails.primaryGuestProfileId }" route="guestFolios" />
        </hm-card-inner>
        <hm-card-inner v-if="companyPaymentStatus.folioWithOpenBalance || companyPaymentStatus.openFolios"
                       :title="`${$t('pageRoomReservation.card.company')} #${id2number(reservation.stayDetails.companyProfileId)}`"
                       :title-clickable="true"
                       @clickTitle="$router.push({ name: 'guestFolios', params: { guestProfileId: reservation.stayDetails.companyProfileId }})">
          <spinner-overlay v-if="loadedPage.companyPaymentStatus === false" />
          <payment-status ref="companyPaymentStatus" :payment-status="companyPaymentStatus" :route-params="{ guestProfileId: reservation.stayDetails.companyProfileId }" route="guestFolios" />
        </hm-card-inner>
        <hm-card-inner v-if="(billingContactPaymentStatus.folioWithOpenBalance || billingContactPaymentStatus.openFolios)
                         && reservation.stayDetails.billingContactProfileId !== reservation.stayDetails.companyProfileId
                       && reservation.stayDetails.billingContactProfileId !== reservation.stayDetails.companyProfileId "
                       :title="`${$t('pageRoomReservation.card.billingContact')} #${id2number(reservation.stayDetails.billingContactProfileId)}`"
                       :title-clickable="true"
                       @clickTitle="$router.push({ name: 'guestFolios', params: { guestProfileId: reservation.stayDetails.billingContactProfileId }})">
          <spinner-overlay v-if="loadedPage.billingContactPaymentStatus === false" />
          <payment-status ref="billingContactPaymentStatus" :payment-status="billingContactPaymentStatus" :route-params="{ guestProfileId: reservation.stayDetails.billingContactProfileId }" route="guestFolios" />
        </hm-card-inner>
        <hm-card-inner v-if="!isEmpty(reservation.stayDetails.roomChargeInvoiceRecipientId)
                         && reservation.stayDetails.roomChargeInvoiceRecipientId !== reservation.stayDetails.companyProfileId
                         && reservation.stayDetails.roomChargeInvoiceRecipientId !== reservation.stayDetails.primaryGuestProfileId
                       && !isEmpty(roomChargeInvoiceRecipientPaymentStatus) && (roomChargeInvoiceRecipientPaymentStatus.folioWithOpenBalance || roomChargeInvoiceRecipientPaymentStatus.openFolios)"
                       :title-clickable="true"
                       :title="$t('pageRoomReservation.card.paymentStatusGuestProfile')"
                       @clickTitle="$router.push({ name: 'guestFolios', params: { guestProfileId: reservation.stayDetails.roomChargeInvoiceRecipientId }})">
          <spinner-overlay v-if="loadedPage.sammelrechnung === false" />
          <payment-status ref="roomChargeInvoiceRecipientPaymentStatus2"
                          :payment-status="roomChargeInvoiceRecipientPaymentStatus"
                          :route-params="{ guestProfileId: reservation.stayDetails.roomChargeInvoiceRecipientId}"
                          route="guestFolios" />
        </hm-card-inner>
      </tabable-card-content>
      <tabable-card-content v-if="hasLicense('GuestProfileFolios') && hasLicense('Invoicing')"
                            :title="$t('pageRoomReservation.card.paymentStatusGuestProfile')"
                            :indicator="isEmpty(reservation.stayDetails.roomChargeInvoiceRecipientId) ? null : 'green'"
                            @show="isNil($refs.roomChargeInvoiceRecipientPaymentStatus) ? ()=>{} : $refs.roomChargeInvoiceRecipientPaymentStatus.updateChart()">
        <hm-card-inner>
          <guest-search :required="false"
                        v-model="reservation.stayDetails.roomChargeInvoiceRecipientId"
                        :disabled="evaluate($options.stateMachineConfig.actions.undoPostCharges.condition)"
                        :label="$t('pageRoomReservation.roomChargeInvoiceRecipientId')"
                        :help="$t('pageRoomReservation.roomChargeInvoiceRecipientId_help')" />
        </hm-card-inner>
        <hm-card-inner v-if="!isEmpty(reservation.stayDetails.roomChargeInvoiceRecipientId) && !isEmpty(roomChargeInvoiceRecipientPaymentStatus)"
                       :title="$t('pageRoomReservation.card.paymentStatusGuestProfile')"
                       :title-clickable="true"
                       @clickTitle="$router.push({ name: 'guestFolios', params: { guestProfileId: reservation.stayDetails.roomChargeInvoiceRecipientId }})">
          <payment-status ref="roomChargeInvoiceRecipientPaymentStatus"
                          :payment-status="roomChargeInvoiceRecipientPaymentStatus"
                          :route-params="{ guestProfileId: reservation.stayDetails.roomChargeInvoiceRecipientId}"
                          route="guestFolios" />
        </hm-card-inner>
      </tabable-card-content>
    </tabable-card>

    <tabable-card id="reservation-details" cols="12 6@desktop 6@hd start-1" rows="1 2@desktop">
      <tabable-card-content :title="$t('pageRoomReservation.card.rateDetailsAndPersons')">
        <hm-card-inner id="num-persons" :title="$t('pageRoomReservation.card.persons')">
          <hm-input-select v-model="reservation.stayDetails.numAdults"
                           :disabled="!canEdit || isLocked"
                           :label="$t('pageRoomReservation.numAdults')"
                           name="numAdults"
                           cols="12@mobile 6@tablet 4@desktop">
            <option v-for="item in intArray(100)" :value="item" :disabled="item > (99 - reservation.stayDetails.numChildren)" v-html="item"></option>
          </hm-input-select>
          <hm-input-select v-if="hasLicense('ChildRates')"
                           v-model="reservation.stayDetails.numChildren"
                           :disabled="!canEdit || isLocked"
                           :label="$t('pageRoomReservation.numChildren')"
                           name="numChildren"
                           cols="12@mobile 6@tablet 4@desktop"
                           @input="onUpdateNumChildren()"
                           @change="onUpdateNumChildren()">
            <option v-for="item in intArray(100)" :value="item" :disabled="item > (99 - reservation.stayDetails.numAdults)" v-html="item"></option>
          </hm-input-select>
          <hm-input-select v-for="child in intArray(reservation.stayDetails.numChildren)"
                           v-model="reservation.stayDetails.childAgeCategories[child+1]"
                           :disabled="!canEdit || isLocked"
                           :label="$tc('pageRoomReservation.child', child, { count: child+1 })"
                           :key="child"
                           :required="true"
                           name="childAge"
                           cols="12@mobile 6@tablet 4@desktop">
            <option v-for="item in hotelSettings.ageCategories.all(reservation.stayDetails.childAgeCategories[child+1])" v-if="item.ageQualifier === 'Adult'" :value="item.id" v-html="`${item.name[$shortLocale]}`"></option>
            <option v-for="item in hotelSettings.ageCategories.all(reservation.stayDetails.childAgeCategories[child+1])" v-if="item.ageQualifier !== 'Adult'" :value="item.id" v-html="`${item.name[$shortLocale]} (${item.ageFrom} - ${item.ageUntil})`"></option>
          </hm-input-select>
        </hm-card-inner>
        <hm-card-inner v-if="!isNil(reservation.stayDetails.discount)" :title="$t('pageRoomReservation.card.discount')">
          <hm-input-money :lazy="true"
                          v-model="reservation.stayDetails.discount.percentage"
                          :disabled="!canEdit || isLocked || (!isEmpty(rates) && rates.rates.every((it) => it.posted))"
                          :label="$t('pageRoomReservation.discount')"
                          name="discount"
                          currency="%"
                          validate="max_value:100|min_value:0"
                          cols="12@mobile 6@tablet 4@desktop">
          </hm-input-money>
          <hm-input v-if="hasLicense('DiscountCode')"
                    :lazy="true"
                    v-model="reservation.stayDetails.discount.discountCode"
                    :disabled="!canEdit || isLocked || (!isEmpty(rates) && rates.rates.every((it) => it.posted))"
                    :label="$t('pageRoomReservation.discountCode')"
                    name="discountCode"
                    cols="12@mobile 6@tablet 4@desktop">
          </hm-input>
          <hm-input-money :lazy="true"
                          v-model="reservation.prepayment.amount"
                          :disabled="!canEdit || isLocked"
                          :currency="hotelSettings.details.currency"
                          :label="$t('pageRoomReservation.prepaymentAmount')"
                          :help="$t('pageRoomReservation.prepaymentAmount_help')"
                          :context-help="$t('pageRoomReservation.prePaymentAmount_contextHelp')"
                          name="prepaymentAmount"
                          cols="12@mobile 6@tablet 4@desktop">
          </hm-input-money>
          <hm-input-money v-if="!isEmpty(rates) && !isEmpty(rates.policies) && !isEmpty(rates.policies.prepaymentPolicy) && rates.policies.prepaymentPolicy.amount !== reservation.prepayment.amount"
                          :value="rates.policies.prepaymentPolicy.amount"
                          :currency="hotelSettings.details.currency"
                          :label="$t('pageRoomReservation.calculatedPrepaymentAmount')"
                          disabled
                          name="calculatedPrepaymentAmount"
                          cols="12@mobile 6@tablet 4@desktop">
          </hm-input-money>
        </hm-card-inner>
        <hm-card-inner :full-size="true">
          <rate-editor v-if="!isEmpty(rates)"
                       :rates.sync="rates"
                       :arrival-date="reservation.checkInDate"
                       :departure-date="reservation.checkOutDate"
                       :num-nights="numNights"
                       :locked="!canEdit || isLocked || rateUpdateInProgress"
                       :updating="rateUpdateInProgress"
                       :explanation-text="$t('pageRoomReservation.hintCompareReservationToRatesToFolio')" />
        </hm-card-inner>
      </tabable-card-content>
      <tabable-card-content :title="$t('pageRoomReservation.card.policies')">
        <template v-if="!isNil(rates) && !isNil(rates.policies)">
          <hm-card-inner>
            <hm-input-select v-model="rates.policies.policyOverride"
                             :label="$t('pageRoomReservation.policies.policyOverride')"
                             no-select-label>
              <option :value="null">{{ $t('pageRoomReservation.policies.policyOverrideNoSelectOption') }}</option>
              <option v-for="itItem in hotelSettings.policies.all(rates.policies.policyOverride)"
                      :key="itItem.id"
                      :value="itItem.id">{{ itItem.name }}
              </option>
            </hm-input-select>
          </hm-card-inner>
          <hm-card-inner>
            <policies :rates="rates"/>
          </hm-card-inner>
        </template>
      </tabable-card-content>
    </tabable-card>

    <tabable-card v-if="hasLicense('Invoicing') || !isEmpty(paymentRequests)" id="online-payments" cols="12 6@desktop start-7@desktop" rows="2 start-3@hd">
      <tabable-card-content v-if="hasLicense('Invoicing')" :title="$t('pageRoomReservation.card.reservationFolios')">
        <hm-card-inner v-if="!isNil(folios)" :full-size="true">
          <spinner-overlay v-if="loadedPage.reservationFolios === false" />
          <folio-table :folios="folios" :items-per-page="5" />
        </hm-card-inner>
      </tabable-card-content>
      <tabable-card-content :display="!isEmpty(paymentRequests)" :title="$t('pageRoomReservation.card.onlinePayments')" :indicator="(paymentRequests || []).some(it => ['Cancelled', 'Failed', 'Unknown'].includes(it.status)) ? 'orange' : ((paymentRequests || []).some(it => ['Initial', 'InProgress'].includes(it.status)) ? 'green' : null)">
        <spinner-overlay v-if="loadedPage.onlinePayments === false" />
        <hm-card-inner :full-size="true">
          <paginated-table columns="4" grid-template-columns="repeat(5, auto)" :rows="paymentRequests" :items-per-page="5">
            <template slot="table-head">
              <div class="hm-table__th">#</div>
              <div class="hm-table__th">{{ $t('pageRoomReservation.onlinePayments.createdAt') }}</div>
              <div class="hm-table__th">{{ $t('pageRoomReservation.onlinePayments.type') }}</div>
              <div class="hm-table__th">{{ $t('pageRoomReservation.onlinePayments.status') }}</div>
              <div class="hm-table__th">{{ $t('pageRoomReservation.onlinePayments.amount') }}</div>
            </template>
            <template v-slot:default="slotProps">
              <template v-for="paymentRequest in slotProps.currentPage">
                <div class="hm-table__td" @click="$router.push({ name: 'reservationPaymentRequest', params: { ...$route.params, paymentRequestId: paymentRequest.id }})">{{ paymentRequest.id | id2number }}</div>
                <div class="hm-table__td" @click="$router.push({ name: 'reservationPaymentRequest', params: { ...$route.params, paymentRequestId: paymentRequest.id }})">{{ paymentRequest.createdAt | toLocalDateTime }}</div>
                <div class="hm-table__td" @click="$router.push({ name: 'reservationPaymentRequest', params: { ...$route.params, paymentRequestId: paymentRequest.id }})">{{ paymentRequest.type }}</div>
                <div :class="[{ 'color--red text--bold': paymentRequest.status !== 'Complete' }]" class="hm-table__td" @click="$router.push({ name: 'reservationPaymentRequest', params: { ...$route.params, paymentRequestId: paymentRequest.id }})">{{ paymentRequest.status }}</div>
                <div class="hm-table__td" @click="$router.push({ name: 'reservationPaymentRequest', params: { ...$route.params, paymentRequestId: paymentRequest.id }})">{{ paymentRequest.amount | toCurrency }} {{ paymentRequest.currency }}</div>
              </template>
            </template>
          </paginated-table>
        </hm-card-inner>
      </tabable-card-content>
    </tabable-card>

    <card :title="$t('pageRoomReservation.card.correspondence')" cols="12 6@desktop start-7@hd" rows="start-5@hd" min-height="25rem">
      <hm-card-inner :full-size="true">
        <hm-col v-if="!isNil(correspondence)" cols="12">
          <spinner-overlay v-if="loadedPage.correspondence === false" />
          <correspondence-table :correspondence="correspondence" :items-per-page="5" />
        </hm-col>
      </hm-card-inner>
    </card>

    <card id="history"
          v-if="hasRole('ROLE_ADMIN')"
          v-once
          :title="$t('pageRoomReservation.card.editHistory')"
          cols="12"
          card-type="collapsible">
      <hm-card-inner :full-size="true">
        <history-table :history="history" />
      </hm-card-inner>
    </card>

    <card v-if="!isEmpty(reservation.additionalFields)"
          id="additionalFields"
          :title="$t('pageRoomReservation.card.additionalFields')"
          cols="12"
          card-type="collapsible">
      <hm-card-inner v-if="!isEmpty(reservation.additionalFields) && !isEmpty(reservation.additionalFields.HM_ROOM_AUTO_ASSIGN)">
        <hm-col cols="2@hd 3@desktop 4@tablet 12@mobile" class="text--bold">
          {{ $t('pageRoomReservation.card.overbooking') }}
        </hm-col>
        <hm-col cols="10@hd 9@desktop 8@tablet 12@mobile">
          <pre style="white-space: break-spaces;margin: 0;" v-safe-html="reservation.additionalFields.HM_ROOM_AUTO_ASSIGN"></pre>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner v-if="!isEmpty(reservation.additionalFields) && !isEmpty(reservation.additionalFields.IBE_PSP)">
        <hm-col cols="2@hd 3@desktop 4@tablet 12@mobile" class="text--bold">
          IBE_PSP
        </hm-col>
        <hm-col cols="10@hd 9@desktop 8@tablet 12@mobile">
          <pre style="white-space: break-spaces;margin: 0;" v-safe-html="reservation.additionalFields.IBE_PSP"></pre>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner v-if="!isEmpty(reservation.additionalFields)">
        <template v-for="(value, key) in reservation.additionalFields">
          <template v-if="!isEmpty(key) && !isEmpty(value) && (key.startsWith('HotelSpider') || key.startsWith('SalesBox') || key.startsWith('ConnectS') || key.startsWith('ConnectCX') || key.startsWith(hotelSettings.hotel.whiteLabel))">
            <hm-col :key="`${key}-key`" cols="2@hd 3@desktop 4@tablet 12@mobile" class="text--bold">
              {{ key }}
            </hm-col>
            <hm-col :key="`${key}-value`" cols="10@hd 9@desktop 8@tablet 12@mobile"><pre style="white-space: break-spaces;margin: 0;margin-bottom: 1.5rem;">{{ value.trim() }}</pre></hm-col>
          </template>
        </template>
      </hm-card-inner>
    </card>

    <modal v-if="showSeamKeyDetail"
           :hide-buttons="true"
           title="Access Codes"
           @cancel="showSeamKeyDetail = false">
      <hm-card-inner full-size>
        <hm-col cols="12">
          <span class="warning-text warning-text--full-size warning-text--no-margin col-12">We strongly advice to <u>NOT</u> modify codes in here directly, as any changes, may either cause unintended side effects or be overwritten automatically.</span>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner :full-size="true">
        <hm-col v-if="!isNil(seamAccessToken)" cols="12">
          <seam-access-code-table :client-session-token="seamAccessToken"
                                  :device-id="seamKey.additionalFields.SEAM_DEVICE_ID"
                                  :disable-delete-access-code="false"
          />
        </hm-col>
      </hm-card-inner>
    </modal>

    <modal v-if="showAddTransactionModal"
           :close-on-click-outside="false"
           :hide-on-submit="false"
           :title="$t('pageRoomReservation.card.addAdditionalService')"
           :confirm-label="$t('pageRoomReservation.confirmAddAdditionalService')"
           @confirm="addShoppingCartItem"
           @cancel="showAddTransactionModal=false">
      <hm-card-inner min-height="35.8rem">
        <hm-col :grid="true" cols="12">
          <span v-if="reservation.status == 'InHouse'" class="warning-text col-12">{{ $t('pageRoomReservation.hintAddAdditionalServiceInHouseReservation') }}</span>
          <hm-input-select v-model="newShoppingCartItem.inHouseServiceId" :label="$t('pageRoomReservation.transactionCode')" name="transactionCode" @input="onChangeShoppingCartItemId">
            <option :value="null" :disabled="true"></option>
            <optgroup v-for="group in additionalServices" :label="group.group">
              <option v-for="item in group.options" v-if="!isNil(item.amount)" :value="item.id" v-html="item.name"></option>
            </optgroup>
          </hm-input-select>
          <hm-input-number v-model="newShoppingCartItem.itemCount" :label="$t('pageRoomReservation.itemCount')" name="itemCount" cols="6" />
          <hm-input-money v-model="newShoppingCartItem.itemPrice"
                          :currency="hotelSettings.details.currency"
                          :label="$t('pageRoomReservation.itemPrice')"
                          name="itemPrice"
                          cols="6" />
          <hm-input v-model="newShoppingCartItem.alternativeLabel" :label="$t('pageRoomReservation.itemAlternativeLabel')" name="alternativeLabel" cols="6" />
          <hm-input-date v-if="newShoppingCartItem.date != null"
                         v-model="newShoppingCartItem.date"
                         :max-date="reservation.checkOutDate"
                         :min-date="reservation.checkInDate"
                         :min-date-inclusive="true"
                         :label="$t('pageRoomReservation.itemDate')"
                         name="itemDate"
                         cols="6" />
        </hm-col>
      </hm-card-inner>
    </modal>

    <modal v-if="showCharPmsLinkKeyCardModal"
           :close-on-click-outside="false"
           :hide-on-submit="false"
           :title="$t('pageRoomReservation.card.charPmsLinkKeyCard')"
           :confirm-label="$t('pageRoomReservation.createCharPmsLinkKeyCard')"
           :button2-disabled="() => !isNil(charPmsLinkStatus)"
           @confirm="createCharPmsLinkKeyCard"
           @cancel="showCharPmsLinkKeyCardModal=false">

      <hm-card-inner>
        <hm-input :value="charPmsLinkKeyCard.key.roomNumber"
                  :label="$t('pageRoomReservation.charPmsLinkKeyCard.roomNumber')"
                  disabled />
        <hm-multiselect v-model="charPmsLinkKeyCard.key.extraAccess"
                        :options="charPmsLinkKeyCard.extraAccess.map(it => ({ id: it, name: it }))"
                        :label="$t('pageRoomReservation.charPmsLinkKeyCard.extraAccess')"
                        label-expression="${option.name}"
        />
        <hm-input-select v-model="charPmsLinkKeyCard.key.encoder"
                         :label="$t('pageRoomReservation.charPmsLinkKeyCard.encoder')"
                         label-expression="${option.name}"
                         no-select>
          <option v-for="it in charPmsLinkKeyCard.encoders" :value="it" v-html="it"/>
        </hm-input-select>
        <hm-input-number v-model="charPmsLinkKeyCard.key.numberOfCards"
                         :label="$t('pageRoomReservation.charPmsLinkKeyCard.numberOfCards')"
                         :min-fraction-digits="0"
                         :max-fraction-digits="0"
                         validate="min_value:1|max_value:10" />
      </hm-card-inner>
      <hm-card-inner>
        <hm-input-date v-model="charPmsLinkKeyCard.key.arrivalDate"
                       :label="$t('pageRoomReservation.charPmsLinkKeyCard.arrivalDate')"
                       name="arrivalDate" />
        <hm-input-time-of-day-slider v-model="charPmsLinkKeyCard.key.arrivalTime"
                                     :step="0.25"
                                     :label="$t('pageRoomReservation.charPmsLinkKeyCard.arrivalTime')"
                                     fa-icon="fak fa-thin-person-walking-luggage-clock fa-lg"
                                     name="arrivalTime" />
        <hm-input-date v-model="charPmsLinkKeyCard.key.departureDate"
                       :label="$t('pageRoomReservation.charPmsLinkKeyCard.departureDate')"
                       name="departureDate" />
        <hm-input-time-of-day-slider v-model="charPmsLinkKeyCard.key.departureTime"
                                     :step="0.25"
                                     :label="$t('pageRoomReservation.charPmsLinkKeyCard.departureTime')"
                                     fa-icon="fak fa-thin-person-walking-luggage-clock fa-lg"
                                     name="arrivalTime" />
      </hm-card-inner>
      <hm-card-inner v-if="isNil(charPmsLinkStatus)" :full-size="true" min-height="5rem">
        <hm-col cols="12">
          <span class="info-text info-text--full-size info-text--no-margin col-12" v-html="$t('pageRoomReservation.charPmsLinkKeyCard.infoText20Seconds', [charPmsLinkKeyCard.encoderWaitSeconds])"></span>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner v-else-if="isNumber(charPmsLinkStatus)" :full-size="true" min-height="5rem">
        <hm-col cols="12">
          <div class="text-center countdown" :class="[{'color--warn': (charPmsLinkStatus <= 5 && charPmsLinkStatus > 0)}, {'color--red': (charPmsLinkStatus === 0) }]">00:{{padStart(charPmsLinkStatus, 2, '0')}}</div>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner v-else :full-size="true" min-height="5rem">
        <hm-col cols="12">
          <span class="error-text error-text--full-size error-text--no-margin col-12">{{ charPmsLinkStatus }}</span>
        </hm-col>
      </hm-card-inner>
    </modal>

    <template v-if="!isEmpty(reservationGroup) && !isEmpty(reservationGroup.roomReservations) && !isEmpty(reservation)">
      <payment-request-wizard
        v-if="paymentRequestsWizardActive"
        :room-reservations="reservationGroup.roomReservations"
        :confirmation-number="reservation.confirmationNumber"
        :guest-profile-id="defaultPaymentRequestGuestProfileId"
        @close="closePaymentRequestWizard" />
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <template v-if="reservation.creationStatus === 'Confirmed'">
        <hm-floating-button v-if="actions.length > 1 || (channelManagerLock && reservation.managedBy !== 'Hotelmeister') || hasLicense('InterfaceSmartpricing')" :label="$t('pageRoomReservation.actions.more')" icon="fill-more" color="gray">
          <hm-floating-child-button v-if="hasLicense('InterfaceSmartpricing')"
                                    :throttle="5000"
                                    :label="$t('pageRoomReservation.resendToSmartpricing')"
                                    color="orange"
                                    icon="upload"
                                    @click="resendToSmartpricing()" />
          <hm-floating-child-button v-if="channelManagerLock && reservation.managedBy !== 'Hotelmeister'"
                                    :label="$t('pageRoomReservation.actions.unlockReservation')"
                                    icon="unlock"
                                    color="orange"
                                    @click="showModal ($t('pageRoomReservation.unlockReservationWarning'), () => { channelManagerLock = false; })" />
          <hm-floating-child-button v-for="action in actions"
                                    :throttle="2000"
                                    :key="action.id"
                                    :icon="action.icon"
                                    :label="$t(`pageRoomReservation.actions.${action.id}`)"
                                    :color="action.color"
                                    @click="onClickFloatingButton(action.id)" />
        </hm-floating-button>
        <hm-floating-button :label="$t('pageRoomReservation.actions.moreAdd')" icon="plus" color="blue">
          <hm-floating-child-button v-if="canIssueKeyCard"
                                    :label="$t('pageRoomReservation.actions.issueKeyCard')"
                                    :disabled="updatingKeys || isEmpty(reservation.stayDetails.roomNumber)"
                                    icon="plus"
                                    color="blue"
                                    @click="addKeyCard()" />
          <hm-floating-child-button v-if="canIssueKeyCode"
                                    :label="$t('pageRoomReservation.actions.issueKeyCode')"
                                    :disabled="updatingKeys || isEmpty(reservation.stayDetails.roomNumber)"
                                    icon="plus"
                                    color="blue"
                                    @click="addKey()" />
          <hm-floating-child-button v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                                    :label="`${$t('pageRoomReservation.actions.createSeamGrant')} 🔒`"
                                    :disabled="updatingKeys || isEmpty(reservation.stayDetails.roomNumber)"
                                    icon="plus"
                                    color="blue"
                                    @click="crateSeamGrant()" />
          <hm-floating-child-button v-if="canEdit"
                                    :label="$t('pageRoomReservation.actions.addAdditionalGuests')"
                                    icon="plus"
                                    color="blue"
                                    @click="addAdditionalGuest(null)" />
          <hm-floating-child-button v-if="canEdit && hasLicense('AdditionalServices')"
                                    :disabled="isLocked"
                                    :label="$t('pageRoomReservation.actions.addAdditionalService')"
                                    icon="plus"
                                    color="blue"
                                    @click="showAddTransactionModal = true" />
          <hm-floating-child-button v-if="hasLicense('InterfaceMeldeblatt')"
                                    :throttle="2000"
                                    :label="$t('pageRoomReservation.actions.addMeldeblatt')"
                                    icon="plus"
                                    color="blue"
                                    @click="createMeldeblatt(false)" />
          <hm-floating-child-button v-if="hasLicense('InterfaceMeldeblatt') && reservationGroupReservations > 1"
                                    :throttle="2000"
                                    :label="$t('pageRoomReservation.actions.addGroupMeldeblatt')"
                                    icon="plus"
                                    color="blue"
                                    @click="createMeldeblatt(false, false, 'ReservationGroup')" />
          <hm-floating-child-button v-if="canEdit"
                                    :label="$t('pageRoomReservation.actions.addDocument')"
                                    icon="plus"
                                    color="blue"
                                    @click="$router.push({ name: 'reservationDocument', params: $route.params})" />
          <hm-floating-child-button :label="$t('pageRoomReservation.actions.addEmail')" icon="plus" color="blue" @click="$router.push({ name: 'reservationEmail', params: $route.params})" />
          <hm-floating-child-button v-if="canEdit && hasLicense('PaymentRequests')"
                                    :label="$t('pageRoomReservation.actions.addDepositPaymentRequest')"
                                    icon="plus"
                                    color="blue"
                                    @click="createDepositPaymentRequest" />
        </hm-floating-button>
      </template>
      <hm-floating-button v-if="isEmpty(reservation.roomChargeInvoiceRecipientId) && hasLicense('Invoicing')"
                          :label="$t('pageRoomReservation.actions.openFolios')"
                          icon="receipt"
                          color="orange"
                          @click="$router.push({name: 'reservationFolios', params: {reservationId: reservationId}})" />
      <!-- eslint-disable vue/no-confusing-v-for-v-if -->
      <hm-floating-button v-for="action in actions"
                          v-if="actions.length == 1"
                          :throttle="3000"
                          :key="action.id"
                          :icon="action.icon"
                          :label="$t(`pageRoomReservation.actions.${action.id}`)"
                          :color="action.color"
                          @click="onClickFloatingButton(action.id)" />
      <hm-floating-button v-if="!isNil(primaryAction)"
                          :throttle="3000"
                          :icon="primaryAction.icon"
                          :label="$t(`pageRoomReservation.actions.${primaryAction.id}`)"
                          :color="primaryAction.color"
                          @click="onClickFloatingButton(primaryAction.id)" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  cloneDeep,
  debounce, find, first,
  get,
  groupBy,
  isArray,
  isEmpty,
  isNil,
  last, map,
  nth,
  omit,
  reverse,
  sortBy,
  template,
  uniqBy,
  isNumber,
  padStart
} from 'lodash';
import HmCol from '../lib/layout/HmCol';
import HmInput from '../lib/inputs/HmInput';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmTextarea from '../lib/inputs/HmTextarea';
import HmFloatingChildButton from '../lib/inputs/HmFloatingChildButton';
import HmCardInner from '../lib/layout/HmCardInner';
import CorrespondenceTable from '../lib/table/CorrespondenceTable';
import TabableCard from '../lib/layout/TabableCard';
import TabableCardContent from '../lib/layout/TabableCardContent';
import uuid from 'uuid';
import TimerMixin from '../../mixins/TimerMixin';
import HmTable from '../lib/table/HmTable';
import SpinnerOverlay from '../lib/util/SpinnerOverlay';
import PaymentRequestWizard from '../lib/finance/PaymentRequestWizard';
import HmInputTimeOfDaySlider from '../lib/inputs/HmInputTimeOfDaySlider.vue';
import HmInputToggle from '../lib/inputs/HmInputToggle.vue';
import FilterMixin from '../../mixins/FilterMixin';
import HmInputMoney from '../lib/inputs/HmInputMoney.vue';
import HmInputSelect from '../lib/inputs/HmInputSelect.vue';
import Policies from '../lib/util/Policies.vue';
import HmMultiselect from '../lib/inputs/HmMultiselect.vue';
import HmInputNumber from '../lib/inputs/HmInputNumber.vue';
import hotelSettingsMixin from '../../mixins/HotelSettingsMixin';
import HmInputDate from '../lib/inputs/HmInputDate.vue';
import Quote from '../lib/util/Quote.vue';

export default {
  name: 'PageRoomReservation',
  components: {
    Quote,
    HmInputDate,
    HmInputNumber,
    HmMultiselect,
    Policies,
    HmInputSelect,
    HmInputMoney,
    HmInputToggle,
    HmInputTimeOfDaySlider,
    PaymentRequestWizard,
    SpinnerOverlay,
    HmTable,
    TabableCardContent,
    TabableCard,
    CorrespondenceTable,
    HmCardInner,
    HmFloatingChildButton,
    HmTextarea,
    HmInput,
    HmCol },

  mixins: [HotelmeisterMixin, SaveWatchMixin, TimerMixin, FilterMixin],

  autosave: [
    {
      name: 'reservation',
      variable: 'reservation',
      fn: function (cbSaveComplete) {
        if (this.reservation.creationStatus !== 'Confirmed') {
          cbSaveComplete();
          return;
        }

        const reservation = cloneDeep(this.reservation);

        if (!isNil(reservation.additionalFields.HMC_ROOMPLAN_ICONS)) {
          try {
            reservation.additionalFields.HMC_ROOMPLAN_ICONS = JSON.stringify(reservation.additionalFields.HMC_ROOMPLAN_ICONS);
          } catch (e) {
            reservation.additionalFields.HMC_ROOMPLAN_ICONS = null;
          }
        }

        this.axios.put(this.serviceUrls.reservation.get(this, this.reservationId), reservation)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
            this.updateHistory();
            try {
              this.as__pauseAutosave('reservation');
              this.reservation.shortInternalComment = response.data.data.shortInternalComment;
              this.reservation.colorCategoryCssClass = response.data.data.colorCategoryCssClass;
              this.reservation.stayDetails.internalComment = response.data.data.internalComment;
              this.reservation.stayDetails.guestComment = response.data.data.guestComment;
            } finally {
              this.as__continueAutosave('reservation');
            }
          })
          .catch((error) => {
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
      exclude: ['checkInDate', 'checkOutDate', 'status', 'stayDetails.arrivalDate', 'stayDetails.departureDate', 'stayDetails.numAdults', 'stayDetails.numChildren', 'stayDetails.childAgeCategories', 'stayDetails.discount', 'stayDetails.roomTypeId', 'stayDetails.ratePlanId', 'history', 'stayDetails.roomKeys', 'stayDetails.policies'],
    },
    {
      name: 'reservationDateAndPersons',
      variable: 'reservation',
      fn: function (cbSaveComplete) {
        if (this.reservation.creationStatus !== 'Confirmed') {
          cbSaveComplete();
          return;
        }
        this.rateUpdateInProgress = true;

        const reservation = cloneDeep(this.reservation);

        if (!isNil(reservation.additionalFields.HMC_ROOMPLAN_ICONS)) {
          try {
            reservation.additionalFields.HMC_ROOMPLAN_ICONS = JSON.stringify(reservation.additionalFields.HMC_ROOMPLAN_ICONS);
          } catch (e) {
            reservation.additionalFields.HMC_ROOMPLAN_ICONS = null;
          }
        }

        this.axios.put(this.serviceUrls.reservation.get(this, this.reservationId), reservation)
          .then((response) => {
            this.showMessages(response);
            this.as__pauseAutosave('reservationDateAndPersons');
            this.as__pauseAutosave('rates');
            this.updateReservationRates()
              .finally(() => {
                this.as__continueAutosave('reservationDateAndPersons');
                this.as__continueAutosave('rates');
              });
            cbSaveComplete();
            this.updateHistory();
            try {
              // need to pause "reservation" autosave as this is the one saving the fields being chagned in try-block
              this.as__pauseAutosave('reservation');
              this.reservation.shortInternalComment = response.data.data.shortInternalComment;
              this.reservation.colorCategoryCssClass = response.data.data.colorCategoryCssClass;
              this.reservation.stayDetails.internalComment = response.data.data.internalComment;
              this.reservation.stayDetails.guestComment = response.data.data.guestComment;
            } finally {
              this.as__continueAutosave('reservation');
            }
          })
          .catch((error) => {
            this.rateUpdateInProgress = false;
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
      include: ['checkInDate', 'checkOutDate', 'stayDetails.arrivalDate', 'stayDetails.departureDate', 'stayDetails.numAdults', 'stayDetails.numChildren', 'stayDetails.childAgeCategories', 'stayDetails.discount', 'stayDetails.roomTypeId', 'stayDetails.ratePlanId', 'stayDetails.policies'],
    },
    {
      name: 'rates',
      variable: 'ratesToSave',
      fn: function (cbSaveComplete) {
        if (this.reservation.creationStatus !== 'Confirmed') {
          cbSaveComplete();
          return;
        }
        this.rateUpdateInProgress = true;

        const rates = cloneDeep(this.rates);
        if (!isEmpty(rates.policies)) {
          rates.policyOverride = rates.policies.policyOverride;
        }

        this.axios.put(this.serviceUrls.reservation.rates(this, this.reservationId), rates)
          .then((response) => {
            this.showMessages(response);
            this.updateReservationRatesSummary();
            this.rateUpdateInProgress = false;
            cbSaveComplete();
            this.updateHistory();
          })
          .catch((error) => {
            // 409 is (in this case) returned when we are still waiting for a data update to finish
            if (error.status === 409) return;
            this.updateReservationRates();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
      exclude: ['policies.cancellationPolicy', 'policies.prepaymentPolicy', 'policies.noShowPolicy', 'policies.guaranteePolicyType'],
      // exclude: ['unitPriceSummary', 'shoppingCartSummary'],
    },
  ],

  stateMachineConfig: {
    config: {
      CreationFailed: ['revive'],
      Initial: ['createAndConfirm', 'create', 'failCreate', 'createAwaitPayment'],
      AwaitingPayment: ['createAndConfirmWithPayment', 'createWithPayment', 'failCreatePayment', 'createAndSkipPayment'],
      NonGuaranteed: ['checkIn', 'cancel', 'expire', 'confirm', 'noShow', 'postCharges', 'undoPostCharges'],
      Guaranteed: ['checkIn', 'cancel', 'expire', 'unconfirm', 'noShow', 'postCharges', 'undoPostCharges'],
      Cancelled: ['undoCancel'],
      RequestExpired: ['undoCancel'],
      NoShow: ['undoCancel', 'undoNoShow'],
      InHouse: ['checkOut', 'undoCheckIn', 'postCharges', 'undoPostCharges'],
      Departed: ['undoCheckOut'],
    },
    actions: {
      createAndConfirm: {
        id: 'createAndConfirm',
        display: false,
      },
      create: {
        id: 'create',
        display: false,
      },
      failCreate: {
        id: 'failCreate',
        display: false,
      },
      failCreatePayment: {
        id: 'failCreate',
        display: false,
      },
      createAndConfirmWithPayment: {
        id: 'failCreate',
        display: false,
      },
      createWithPayment: {
        id: 'failCreate',
        display: false,
      },
      createAwaitPayment: {
        id: 'createAwaitPayment',
        display: false,
      },
      revive: {
        id: 'revive',
        color: 'error',
        icon: 'undo',
        label: 'Wiederbeleben',
        condition: 'hasRole(\'ROLE_SYSADMIN\')',
      },
      createAndSkipPayment: {
        id: 'createAndSkipPayment',
        color: 'orange',
        icon: 'save',
        label: 'Zahlung überspringen',
        condition: 'hasRole(\'ROLE_ADMIN\')',
      },
      undoPostCharges: {
        id: 'undoPostCharges',
        color: 'orange',
        icon: 'undo',
        label: 'Leistungen verbuchen rückgängig',
        condition: 'canEdit && hasLicense(\'Invoicing\') && rates != null && (rates.rates.filter(it => it.posted === true).length > 0 || rates.shoppingCart.filter(it => it.posted === true).length > 0)',
      },
      postCharges: {
        id: 'postCharges',
        color: 'orange',
        icon: 'plus',
        label: 'Leistungen verbuchen',
        condition: 'canEdit && hasLicense(\'Invoicing\') && rates != null && (rates.rates.filter(it => it.posted === false).length > 0 || rates.shoppingCart.filter(it => it.posted === false).length > 0)',
      },
      confirm: {
        id: 'confirm',
        color: 'mint',
        icon: 'save',
        label: 'Reservierung garantieren',
        condition: 'canEdit',
      },
      expire: {
        id: 'expire',
        color: 'error',
        icon: 'clock',
        label: 'Option abgelaufen',
        condition: 'canEdit && !isLocked && reservation.type === "OnRequest"',
      },
      unconfirm: {
        id: 'unconfirm',
        color: 'orange',
        icon: 'undo',
        label: 'Reservierung nicht garantieren',
        condition: 'canEdit',
      },
      cancel: {
        id: 'cancel',
        color: 'error',
        icon: 'close',
        label: 'Stornieren',
        condition: 'canEdit && !isLocked',
      },
      noShow: {
        id: 'noShow',
        color: 'error',
        icon: 'close',
        label: 'NoShow',
        condition: 'canEdit && !isLocked',
      },
      checkIn: {
        id: 'checkIn',
        color: 'mint',
        icon: 'checkin',
        label: 'CheckIn',
        condition: 'canEdit',
      },
      checkOut: {
        id: 'checkOut',
        color: 'mint',
        icon: 'checkout',
        label: 'CheckOut',
        condition: 'canEdit',
      },
      undoCancel: {
        id: 'undoCancel',
        color: 'orange',
        icon: 'undo',
        label: 'Storno rückgängig',
        condition: 'canEdit && !isLocked',
      },
      undoNoShow: {
        display: false,
        id: 'undoNoShow',
        color: 'orange',
        icon: 'undo',
        label: 'NoShow rückgängig',
        condition: 'canEdit && !isLocked',
      },
      undoCheckIn: {
        id: 'undoCheckIn',
        color: 'orange',
        icon: 'undo',
        label: 'CheckIn rückgängig',
        condition: 'canEdit',
      },
      undoCheckOut: {
        id: 'undoCheckOut',
        color: 'orange',
        icon: 'undo',
        label: 'CheckOut rückgängig',
        condition: 'canEdit',
      },
    },
  },

  data() {
    return {
      init: false,
      keyChangeCounter: 0,
      keyRefreshCounter: 0,
      debugKeys: false,
      updatingKeys: false,
      paymentRequestsWizardActive: false,
      paymentRequests: [],
      icons: ['plane', 'taxi', 'wine-glass', 'rings-wedding', 'skiing', 'skiing-nordic', 'swimmer', 'users', 'campground', 'key', 'clock', 'moon', 'credit-card-blank', 'phone', 'anchor', 'baby-carriage',
        'bicycle', 'tree-christmas', 'cross', 'hiking', 'golf-club', 'dog', 'car-garage', 'wheelchair', 'money-bill', 'tennis-ball', 'hockey-sticks', 'futbol'],
      reservationGroups: [],
      unavailableRooms: [],
      meldeblaetter: [],
      meldeblattKey: '',
      reservation: null,
      rates: null,
      paymentStatus: {
        balance: 0,
        folioWithOpenBalance: false,
      },
      guestPaymentStatus: {
        balance: 0,
        folioWithOpenBalance: false,
      },
      companyPaymentStatus: {
        balance: 0,
        folioWithOpenBalance: false,
      },
      billingContactPaymentStatus: {
        balance: 0,
        folioWithOpenBalance: false,
      },
      rateUpdateInProgress: false,
      channelManagerLock: true,
      correspondence: null,
      roomChargeInvoiceRecipientPaymentStatus: null,
      fellowTravellers: null,
      folios: null,
      showAddTransactionModal: false,
      newShoppingCartItem: {
        id: uuid.v4(),
        inHouseServiceId: null,
        itemCount: 1,
        itemPrice: 0,
        alternativeLabel: null,
        date: null,
      },
      confirmationNumberLocked: true,
      debouncedUpdateUnavailableRooms: debounce(this.updateUnavailableRooms, 100),
      reservationId: null,
      reservationGroup: null,
      warningMeldeblattNotArrived: false,
      warningMeldeblattDoesNotExist: false,
      history: [],
      loadedPage: {
        meldeblatt: false,
        reservationFolios: false,
        reservationPaymentStatus: false,
        guestPaymentStatus: false,
        companyPaymentStatus: false,
        // travelAgentPaymentStatus: false,
        billingContactPaymentStatus: false,
        fellowTravellers: false,
        onlinePayments: false,
        correspondence: false,
        sammelrechnung: false,
      },
      debounceUpdateKeys: debounce(this.updateKeys, 2500, { maxWait: 5000 }),
      debounceUpdateGuestPaymentStatus: debounce(this.updateGuestPaymentStatus, 250, { maxWait: 500 }),
      debounceUpdateFolios: debounce(this.updateFolios, 250, { maxWait: 500 }),
      debounceUpdateCorrespondence: debounce(this.updateCorrespondence, 250, { maxWait: 500 }),
      debounceUpdateReservationGroup: debounce(this.updateReservationGroup, 500, { maxWait: 5000 }),
      showSeamKeyDetail: false,
      seamAccessToken: null,
      seamKey: null,
      showCharPmsLinkKeyCardModal: false,
      charPmsLinkStatus: null,
      charPmsLinkKeyCard: {
        enabled: false,
        keyCardEnabled: false,
        mobileKeyEnabled: false,
        rooms: [],
        extraAccess: [],
        encoders: [],
        encoderWaitSeconds: 20,
        key: {
          keyManagementConfigurationId: null,
          charPmsLinkConfigId: null,
          roomNumber: null,
          arrivalDate: null,
          arrivalTime: null,
          departureDate: null,
          departureTime: null,
          extraAccess: [],
          encoder: null,
          numberOfCards: 1,
          keyType: 'K',
        },
      },
    };
  },

  computed: {
    keyManagementConfiguration() {
      try {
        if (!this.hasLicense('LockingSystems')) return null;
        const roomConfig = this.hotelSettings.interfaces.hotelKeyManagementConfiguration.rooms[this.reservation.stayDetails.roomNumber]
        if (roomConfig.enabled !== true) return null;
        const configId = roomConfig.keyManagementConfigurationId
        const config = this.hotelSettings.interfaces.hotelKeyManagementConfiguration[configId];
        if (config.enabled !== true) return null;
        return config;
      } catch(ignore) {
        return null;
      }
    },
    canIssueKeyCard() {
      if (!this.hasLicense('LockingSystems')) return false;
      if (this.updatingKeys) return false;
      if (!this.canEdit) return false;
      if (['Departed','Cancelled','NoShow','RequestExpired','Initial','CreationFailed'].includes(this.reservation.status)) return false;
      return this.hasLicense('InterfaceCharPmsLink') && this.hasLicense('InterfaceKeyCard') && (this.keyManagementConfiguration || {}).keyType === 'KeyCard';
    },
    canIssueKeyCode() {
      if (!this.hasLicense('LockingSystems')) return false;
      if (this.updatingKeys) return false;
      if (!this.canEdit) return false;
      if (['Departed','Cancelled','NoShow','RequestExpired','Initial','CreationFailed'].includes(this.reservation.status)) return false;
      if (this.hasAnyLicense(['InterfaceSeam', 'InterfaceLoxone']) && ['PredefinedCode', 'AutoGeneratedCode'].includes((this.keyManagementConfiguration || {}).keyType)) return true;
      if (this.hasAnyLicense(['InterfaceSeam']) && ['SeamLocksAcs'].includes((this.keyManagementConfiguration || {}).lockingSystem)) return true;
      return false;
    },
    hotelSettingsMixin() {
      return hotelSettingsMixin;
    },
    canEdit: function () {
      return this.hasAnyRole(['ROLE_RESERVATION_REQUEST', 'ROLE_RESERVATION_NOTIFICATION', 'ROLE_ADMIN', 'ROLE_SYSADMIN']);
    },
    canEditGuest: function () {
      return true;
    },
    ratesToSave: function () {
      if (isNil(this.rates)) return null;

      let ret = cloneDeep(this.rates);
      ret = omit(ret, 'unitPriceSummary', 'shoppingCartSummary');
      ret.rates = ret.rates.map(it => omit(it, 'taxDetails', 'amount', 'includedTaxAmount', 'excludedTaxAmount', 'originalAmount'));
      return ret;
    },
    reservationGroupReservations: function () {
      return isNil(this.reservationGroup) ? 1 : this.reservationGroup.roomReservations
        .filter(it => it.status !== 'Cancelled')
        .filter(it => it.status !== 'NoShow')
        .filter(it => it.status !== 'RequestExpired')
        .filter(it => it.status !== 'Initial')
        .filter(it => it.status !== 'CreationFailed')
        .length;
    },
    maxArrivalDate: function () {
      return this.$moment().add(this.hotelSettings.details.futureDates - 1, 'days').format('YYYYMMDD');
    },
    maxDepartureDate: function () {
      return this.$moment().add(this.hotelSettings.details.futureDates, 'days').format('YYYYMMDD');
    },
    additionalGuestsActiveCard: function () {
      if (!this.hasLicense('InterfaceMeldeblatt')) {
        if (!isEmpty(this.reservation.stayDetails.additionalGuests)) return 0;
        else if (!isEmpty(this.fellowTravellers)) return 1;
        else return 0;
      }
      if (isNil(this.reservation)) return 0;
      if (this.$moment().isBefore(this.$moment(this.reservation.checkInDate, 'YYYYMMDD'))) {
        if (!isEmpty(this.reservation.stayDetails.additionalGuests)) return 1;
        else if (!isEmpty(this.fellowTravellers)) return 2;
        else return 1;
      }

      return 0;
    },
    additionalServices: function () {
      return [
        ...sortBy(
          Object.entries(groupBy(this.hotelSettings.inHouseServices.all(), it => it.type))
            .map(it => ({
              group: this.$t(`InHouseServiceType.${it[0]}`),
              options: sortBy(it[1].map((ihs) => {
                const ret = {
                  id: ihs.id,
                  name: ihs.name[this.$shortLocale],
                  type: 'InHouseService',
                  amount: ihs.amount,
                };

                if (ihs.rateFrequency === 'PerNight') {
                  ret.name = `${ret.name} (${this.$t('RateFrequency.PerNight')})`;
                }

                return ret;
              }), ihs => ihs.name),
            })),
          it => it.group,
        ),
      ];
    },
    activeGuestCard: function () {
      if (isNil(this.reservation) || isNil(this.reservation.stayDetails)) return 0;

      if (!isNil(this.reservation.stayDetails.primaryGuestProfileId)) {
        return 0;
      } else if (!isNil(this.reservation.stayDetails.companyProfileId)) {
        return 1;
      } else if (!isNil(this.reservation.stayDetails.travelAgentProfileId)) {
        return 2;
      } else {
        return 0;
      }
    },
    isLocked: function () {
      if (isNil(this.reservation)) return false;

      return this.channelManagerLock && this.reservation.managedBy !== 'Hotelmeister';
    },
    numNights: function () {
      if (isNil(this.reservation)) return 1;

      return Math.max(1, this.$moment(this.reservation.checkOutDate, 'YYYYMMDD').diff(this.$moment(this.reservation.checkInDate, 'YYYYMMDD'), 'days'));
    },
    primaryAction: function () {
      let actions = [];
      if (!isNil(this.reservation)) {
        actions = this.$options.stateMachineConfig.config[this.reservation.status];
      }

      if (isNil(actions)) actions = []; // can be the case for statuses where no actions do exist - i.e. CreationFailed

      actions = actions.map(it => this.$options.stateMachineConfig.actions[it]).filter(action => action.display !== false && this.evaluate(action.condition));

      return nth(actions.slice(0, 1), 0);
    },
    actions: function () {
      let actions = [];
      if (!isNil(this.reservation)) {
        actions = this.$options.stateMachineConfig.config[this.reservation.status];
      }

      if (isNil(actions)) actions = []; // can be the case for statuses where no actions do exist - i.e. CreationFailed

      actions = actions.map(it => this.$options.stateMachineConfig.actions[it]).filter(action => action.display !== false && this.evaluate(action.condition));

      return actions.slice(1).reverse();
    },
    additionalGuestIds: function () {
      if (isNil(this.reservation)) return [];

      return this.reservation.stayDetails.additionalGuests.map(it => it.id);
    },
    defaultPaymentRequestGuestProfileId() {
      try {
        return this.reservation.stayDetails.roomChargeInvoiceRecipientId
          || this.reservation.stayDetails.billingContactProfileId
          || this.reservation.stayDetails.companyProfileId
          || this.reservation.stayDetails.primaryGuestProfileId;
      } catch (e) { /* ignore */ }
      return null;
    },
  },

  watch: {
    'keyChangeCounter': function () {
      this.keyRefreshCounter = 0; // reset counter
    },
    'reservation.stayDetails.roomChargeInvoiceRecipientId': function () {
      this.updateRoomChargeInvoiceRecipientPaymentStatus();
    },
    'reservation.stayDetails.companyProfileId': function () {
      this.debounceUpdateGuestPaymentStatus();
      if (this.init) this.setTimeout(() => { this.debounceUpdateFolios(); }, 500);
    },
    'reservation.stayDetails.billingContactProfileId': function () {
      this.debounceUpdateGuestPaymentStatus();
      if (this.init) this.setTimeout(() => { this.debounceUpdateFolios(); }, 500);
    },
    'reservation.stayDetails.primaryGuestProfileId': function () {
      this.updateFellowTravellers();
      this.debounceUpdateGuestPaymentStatus();
      if (this.init) this.setTimeout(() => { this.debounceUpdateFolios(); }, 500);
    },
    'reservation.stayDetails.roomKeys': {
      handler: function () {
        try {
          if (!isNil(this.reservation.stayDetails.roomKeys)) {
            const keysWaitingForCode = this.reservation.stayDetails.roomKeys
              .filter(it => isEmpty(it.code))
              .filter(it => this.hotelSettings.interfaces.hotelKeyManagementConfiguration[it.keyManagementConfigurationId].lockingSystem === 'SeamLocks');

            if (keysWaitingForCode.length > 0) {
              this.debounceUpdateKeys();
            }
          }
        } catch (e) { /* ignore */ }
      },
      deep: true,
    },
    'reservation.checkInDate': function () {
      this.debouncedUpdateUnavailableRooms();
      this.debounceUpdateKeys();
      this.setTimeout(this.validateMeldeblaetter, 500);
    },
    'reservation.checkOutDate': function () {
      this.debouncedUpdateUnavailableRooms();
      this.debounceUpdateKeys();
      this.setTimeout(this.validateMeldeblaetter, 500);
    },
    'reservation.stayDetails.arrivalTime': function () {
      this.debounceUpdateKeys();
    },
    'reservation.stayDetails.departureTime': function () {
      this.debounceUpdateKeys();
    },
    'reservation.status': function () {
      this.debounceUpdateKeys();
    },
    'reservation.confirmationNumber': function (newVal, oldVal) {
      if (isEmpty(oldVal)) this.debounceUpdateReservationGroup(); // only update if we have a new confirmation number
    },
  },

  created: function () {
    this.reservationId = this.$route.params.reservationId;
    this.updateReservation();
    this.updatePaymentStatus();
    this.updateReservationRates();
    this.debounceUpdateCorrespondence();
    this.updatePaymentRequests();

    this.$serviceBus.$on('help.show', this.showHelp);
  },

  methods: {
    isNumber,
    padStart,
    updateReservationGroup() {
      if (isEmpty(this.reservation.confirmationNumber)) {
        this.reservationGroup = null;
        return;
      }

      return this.axios.get(this.serviceUrls.reservationGroup.get(this, this.reservation.confirmationNumber), { params: { paymentData: true } })
        .then((response) => {
          this.reservationGroup = response.data.data;
        });
    },
    showHelp() {
      this.$driver.defineSteps([
        {
          element: '#confirmation-number',
          padding: 5,
          popover: {
            title: 'Bestätigungsnummer',
            description: 'Mit einem Klick auf die Bestätigungsnummer gelangen Sie zur Gruppenreservierung und können alle Reservierungen mit der gleichen Bestätigungsnummer anzeigen.',
            position: 'bottom-center',
          },
        },
        {
          element: '#room-number-locked',
          padding: 5,
          popover: {
            title: 'Zimmernummer gesperrt',
            description: 'Reservierungen mit gesperrter Zimmernummer können am Zimmerplan nicht mehr in ein anderes Zimmer verschoben werden. Um die zugewiesene Zimmernummer zu ändern, muss die Reservierung geöffnet werden.',
            position: 'bottom-center',
          },
        },
        {
          element: '#payment-status',
          popover: {
            title: 'Zahlungsstatus',
            description: 'Zahlungsstatus der Reservierung und der Sammelrechnung (wenn zutreffend)',
            position: 'top-center',
          },
        },
        {
          element: '#num-persons',
          padding: 15,
          popover: {
            title: 'Personenanzahl',
            description: 'Anzahl der Erwachsenen und Kinder',
            position: 'top-center',
          },
        },
        {
          element: '#history',
          popover: {
            title: 'Bearbeitungsverlauf',
            description: 'Hier können Sie Änderungen der Reservierung nachverfolgen, wenn Sie z.B. wissen möchten wer, wann das Abreisedatum der Reservierung verändert hat.',
            position: 'top-center',
          },
        },
      ]);
      this.$driver.start();
    },
    unlockConfirmationNumber($event) {
      $event.stopPropagation();
      this.confirmationNumberLocked = false;
      this.updateReservationGroups();
    },
    validateMeldeblaetter(validate = true) {
      if (this.meldeblattKey === '') return;

      if (this.reservation.status === 'InHouse') {
        const activeMeldeblaetter = this.meldeblaetter
          .filter(it => it.status !== 'Deleted')
          .length;

        const draftMeldeblaetter = this.meldeblaetter
          .filter(it => it.status !== 'Deleted')
          .filter(it => it.status !== 'Sent')
          .filter(it => it.status !== 'Departed')
          .length;

        const sentMeldeblaetter = this.meldeblaetter
          .filter(it => it.status === 'Sent')
          .filter(it => it.status === 'Departed')
          .length;

        if (this.$route.name === 'reservation' && draftMeldeblaetter >= 1 && sentMeldeblaetter === 0) {
          this.warningMeldeblattNotArrived = true;
          /*
          this.showModal(
            this.$t('pageRoomReservation.confirmReservationInHouseMeldeblattNotArrived'),
            () => {
              this.openMeldeblatt(this.meldeblaetter
                .filter(it => it.status !== 'Deleted')
                .filter(it => it.status !== 'Departed')
                .filter(it => it.status !== 'Sent')[0].id);
            },
          );
           */
        } else {
          this.warningMeldeblattNotArrived = false;
        }

        if (this.$route.name === 'reservation' && activeMeldeblaetter === 0) {
          this.warningMeldeblattDoesNotExist = true;
        } else {
          this.warningMeldeblattDoesNotExist = false;
        }
      }

      if (!isEmpty(this.meldeblaetter) && validate === true) {
        let askForMeldeblattUpdate = this.meldeblaetter
          .filter(it => it.status !== 'Departed')
          .filter(it => it.status !== 'Deleted')
          .filter(it => it.anreise !== it.abreise)
          .filter(it => it.abreise !== this.reservation.checkOutDate)
          .length > 0;

        if (askForMeldeblattUpdate === false) {
          askForMeldeblattUpdate = this.meldeblaetter
            .filter(it => it.status !== 'Departed' && it.status !== 'Sent')
            .filter(it => it.anreise !== it.abreise)
            .filter(it => it.anreise !== this.reservation.checkInDate)
            .length > 0;
        }

        if (this.$route.name === 'reservation' && askForMeldeblattUpdate) {
          this.showModal(
            this.$t('pageRoomReservation.confirmMeldeblattDifferentArrivalDepartureDates'),
            () => {
              this.axios.post(this.serviceUrls.reservation.updateMeldeblattDates(this, this.reservationId))
                .then((_) => {
                  this.showSuccessMessage();
                  this.updateMeldeblaetter(false);
                })
                .catch((error) => {
                  this.showMessages(error.response);
                });
            },
          );
        }
      }
    },
    updatePaymentRequests(validate = true) {
      return this.axios.get(this.serviceUrls.paymentRequest.findByReservationId(this, this.reservationId))
        .then((response) => {
          this.paymentRequests = Object.freeze(
            reverse(
              sortBy(
                (response.data.data || []).filter(it => {
                  if (this.hasRole('ROLE_SYSADMIN')) return true;
                  else {
                    if (['Cancelled', 'Failed'].includes(it.status)) {
                      if (it.type === 'FolioBalance' && it.subType === 'Terminal') {
                        return false;
                      } else {
                        return true;
                      }
                    } else {
                      return true;
                    }
                  }
                }),
                'createdAt'
              )
            )
          );
        })
        .finally(() => {
          this.loadedPage.onlinePayments = true;
        });
    },
    updateMeldeblaetter(validate = true) {
      if (!this.hasLicense('InterfaceMeldeblatt')) return Promise.resolve();

      return this.axios.get(this.serviceUrls.meldeblatt.findByReservationId(this, this.reservationId))
        .then((response) => {
          this.meldeblaetter = Object.freeze(response.data.data);

          this.meldeblattKey = uuid.v4();

          this.validateMeldeblaetter(validate);
        })
        .finally(() => {
          this.loadedPage.meldeblatt = true;
        });
    },
    createMeldeblatt(force = false, open = false, type = null) {
      const activeMeldeblaetter = this.meldeblaetter
        .filter(it => it.status !== 'Deleted')
        .length;

      if (force === false && activeMeldeblaetter > 0) {
        this.showModal(
          this.$t('pageRoomReservation.confirmMeldeblattAlreadyExists'),
          () => {
            this.createMeldeblatt(true, open, type);
          },
        );
      } else {
        if (isNil(type)) {
          if (this.reservationGroupReservations > 1) {
            this.show3ButtonModal(
              this.$t('pageRoomReservation.confirmReservationInHouseMeldeblaetterDoesNotExist'),
              this.$t('pageRoomReservation.actions.addMeldeblatt'),
              this.$t('pageRoomReservation.actions.addGroupMeldeblatt'),
              () => {
                this.createMeldeblatt(force, open, 'RoomReservation');
              },
              () => {
                this.createMeldeblatt(force, open, 'ReservationGroup');
              },
              {
                hint: this.$t('pageRoomReservation.confirmReservationInHouseMeldeblaetterDoesNotExist_hint'),
              },
            );
            return;
          } else {
            type = 'RoomReservation';
          }
        }

        let url = this.serviceUrls.meldeblatt.findByReservationId(this, this.reservationId);

        if (type === 'ReservationGroup') {
          url = this.serviceUrls.meldeblatt.findByConfirmationNumber(this, this.reservation.confirmationNumber);
        }

        this.axios.post(url)
          .then((response) => {
            if (open === true && (!isArray(response.data.data) || response.data.data.length === 1)) {
              this.openMeldeblatt(response.data.data);
            } else {
              // delayed because RYOW (read your own write) wasn't fully working because we N1QL refKey index wasn't updated yet
              this.setTimeout(() => {
                this.updateMeldeblaetter();
                this.$refs.additionalGuestsTabableCardContainer.changeCard(0);
                this.showSuccessMessage();
              }, 250);
            }
          })
          .catch((error) => {
            this.showMessages(error.response);
          });
      }
    },
    openMeldeblatt(meldeblattId) {
      this.$router.push({
        name: 'meldeblatt',
        params: {
          meldeblattId: meldeblattId,
        },
      });
    },
    updateUnavailableRooms() {
      if (isEmpty(this.reservation)) return;
      this.axios.post(this.serviceUrls.availability.unavailableRooms(this), {
        arrivalDate: this.reservation.checkInDate,
        departureDate: this.reservation.checkOutDate,
        reservationId: this.reservationId,
      })
        .then((response) => {
          this.unavailableRooms = Object.freeze(response.data.data.unavailableRooms || []);
        });
    },
    updateFolios() {
      this.axios.get(this.serviceUrls.folio.list(this, this.reservationId))
        .then((response) => {
          this.folios = Object.freeze(cloneDeep(response.data.data.folios));
        })
        .finally(() => {
          this.loadedPage.reservationFolios = true;
        });
    },
    deleteGuestDetail: function (guest) {
      this.reservation.stayDetails.additionalGuests.splice(this.reservation.stayDetails.additionalGuests.indexOf(guest), 1);
    },
    addAdditionalGuest: function (guest) {
      if (isNil(guest)) {
        const numPersons = this.reservation.stayDetails.numAdults + this.reservation.stayDetails.numChildren;
        const numGuests = (isNil(this.reservation.stayDetails.additionalGuests) ? 0 : this.reservation.stayDetails.additionalGuests.length) + 1;

        if (numGuests < numPersons) {
          for (let i = numGuests; i < numPersons; i++) {
            this.reservation.stayDetails.additionalGuests.push({
              id: uuid.v4(),
              firstName: null,
              lastName: null,
              dateOfBirth: null,
            });
          }
        } else {
          this.reservation.stayDetails.additionalGuests.push({
            id: uuid.v4(),
            firstName: null,
            lastName: null,
            dateOfBirth: null,
          });
        }

        this.$refs.additionalGuestsTabableCardContainer.changeCard(this.hasLicense('InterfaceMeldeblatt') ? 1 : 0);
      } else {
        this.reservation.stayDetails.additionalGuests.push(guest);
      }
    },
    isEmpty,
    updateFellowTravellers: function () {
      if (!isNil(this.reservation.stayDetails.primaryGuestProfileId)) {
        return this.axios.get(this.serviceUrls.guest.fellowTravellers(this, this.reservation.stayDetails.primaryGuestProfileId))
          .then((response) => {
            let fellowTravellers = response.data.data;

            if (!isEmpty(fellowTravellers)) {
              fellowTravellers = uniqBy(fellowTravellers, it => `${it.firstName}##${it.lastName}##${it.dateOfBirth}`);
            }

            this.fellowTravellers = Object.freeze(fellowTravellers);
          })
          .catch((error) => {
            this.fellowTravellers = null;
          })
          .finally(() => {
            this.loadedPage.fellowTravellers = true;
          });
      } else {
        this.fellowTravellers = null;
        return Promise.resolve();
      }
    },
    updateReservationGroups: function () {
      if (isEmpty(this.reservationGroups)) {
        this.axios.get(this.serviceUrls.reservationGroup.find(this, this.reservation.checkInDate, this.numNights))
          .then((response) => {
            this.reservationGroups = Object.freeze(response.data.data);
          });
      }
    },
    updateRoomChargeInvoiceRecipientPaymentStatus: function () {
      if (!isNil(this.reservation.stayDetails.roomChargeInvoiceRecipientId)) {
        return this.axios
          .get(this.serviceUrls.guest.paymentStatus(this, this.reservation.stayDetails.roomChargeInvoiceRecipientId))
          .then((response) => {
            this.roomChargeInvoiceRecipientPaymentStatus = Object.freeze(response.data.data);
          })
          .catch((error) => {
            this.roomChargeInvoiceRecipientPaymentStatus = null;
          })
          .finally(() => {
            this.loadedPage.sammelrechnung = true;
          });
      } else {
        this.roomChargeInvoiceRecipientPaymentStatus = null;
        return Promise.resolve();
      }
    },
    updateGuestPaymentStatus: function () {
      this.guestPaymentStatus.folioWithOpenBalance = false;
      if (!isEmpty(this.reservation.stayDetails.primaryGuestProfileId)) {
        this.axios
          .get(this.serviceUrls.guest.paymentStatus(this, this.reservation.stayDetails.primaryGuestProfileId))
          .then((response) => {
            this.guestPaymentStatus = response.data.data;
          })
          .catch((error) => {
            this.guestPaymentStatus = {
              balance: 0,
              folioWithOpenBalance: false,
            };
            this.showMessages(error.response);
          })
          .finally(() => {
            this.loadedPage.guestPaymentStatus = true;
          });
      } else {
        this.guestPaymentStatus = {
          balance: 0,
          folioWithOpenBalance: false,
        };
      }

      if (!isEmpty(this.reservation.stayDetails.companyProfileId)) {
        this.axios
          .get(this.serviceUrls.guest.paymentStatus(this, this.reservation.stayDetails.companyProfileId))
          .then((response) => {
            this.companyPaymentStatus = response.data.data;
          })
          .catch((error) => {
            this.companyPaymentStatus = {
              balance: 0,
              folioWithOpenBalance: false,
            };
            this.showMessages(error.response);
          })
          .finally(() => {
            this.loadedPage.companyPaymentStatus = true;
          });
      } else {
        this.companyPaymentStatus = {
          balance: 0,
          folioWithOpenBalance: false,
        };
      }

      if (!isEmpty(this.reservation.stayDetails.billingContactProfileId)) {
        this.axios
          .get(this.serviceUrls.guest.paymentStatus(this, this.reservation.stayDetails.billingContactProfileId))
          .then((response) => {
            this.billingContactPaymentStatus = response.data.data;
          })
          .catch((error) => {
            this.billingContactPaymentStatus = {
              balance: 0,
              folioWithOpenBalance: false,
            };
            this.showMessages(error.response);
          })
          .finally(() => {
            this.loadedPage.billingContactPaymentStatus = true;
          });
      } else {
        this.billingContactPaymentStatus = {
          balance: 0,
          folioWithOpenBalance: false,
        };
      }
    },
    updateHistory: debounce(
      function () {
        // not doing anything for now, because history isn't reactive
        // history reactivity causes the entire page to update and re-render resulting in lazy inputs (e.g. additional guest names) being reset amidst the user typing
        // return this.axios
        //   .get(this.serviceUrls.reservation.get(this, this.reservationId))
        //   .then((response) => {
        //     this.history = cloneDeep(response.data.data.history);
        //   });
      },
      2000,
    ),
    updateReservation: function () {
      return this.axios
        .get(this.serviceUrls.reservation.get(this, this.reservationId))
        .then((response) => {
          const reservation = response.data.data;

          if (!isEmpty(reservation.additionalFields.HMC_ROOMPLAN_ICONS)) {
            try {
              reservation.additionalFields.HMC_ROOMPLAN_ICONS = JSON.parse(reservation.additionalFields.HMC_ROOMPLAN_ICONS);
            } catch (e) {
              reservation.additionalFields.HMC_ROOMPLAN_ICONS = null;
            }
          }

          this.reservation = reservation;
          this.history = cloneDeep(reservation.history);
          this.$nextTick(() => {
            this.init = true;
          });
          // this.updateRoomChargeInvoiceRecipientPaymentStatus();
          // this.updateFellowTravellers();
          // this.debouncedUpdateUnavailableRooms();
          return Promise.all([this.debounceUpdateReservationGroup(), this.updateMeldeblaetter()]);
        });
    },
    updateCorrespondence: function () {
      return this.axios
        .get(this.serviceUrls.reservation.correspondence(this, this.reservationId))
        .then((response) => {
          this.correspondence = Object.freeze(response.data.data);
        })
        .finally(() => {
          this.loadedPage.correspondence = true;
        });
    },
    updateReservationRates: function () {
      this.rateUpdateInProgress = true;
      return this.axios
        .get(this.serviceUrls.reservation.rates(this, this.reservationId))
        .then((response) => {
          if (isNil(this.rates)) {
            this.rates = response.data.data;
          } else {
            this.rates.rates = response.data.data.rates;
            this.rates.shoppingCart = response.data.data.shoppingCart;
            this.rates.unitPriceSummary = response.data.data.unitPriceSummary;
            this.rates.shoppingCartSummary = response.data.data.shoppingCartSummary;
            this.rates.policies = response.data.data.policies;
          }
          this.rates.rates.forEach((it) => {
            if (isNil(it.customAmount)) it.customAmount = it.amount;
          });
          this.rateUpdateInProgress = false;
        })
        .catch((error) => {
          this.rateUpdateInProgress = false;
        });
    },
    updateReservationRatesSummary: function () {
      return this.axios
        .get(this.serviceUrls.reservation.rates(this, this.reservationId))
        .then((response) => {
          if (isNil(this.rates)) {
            this.rates = response.data.data;
          } else {
            // console.log(response.data.data);
            response.data.data.rates.forEach((itRate) => {
              const rate = this.rates.rates.find(it => it.effectiveDate === itRate.effectiveDate);
              rate.amount = itRate.amount;
            });
            // // // console.log(this.rates);
            // // // console.log(response.data.data.rates);
            this.rates.rates.forEach((it) => {
              if (isNil(it.customAmount)) it.customAmount = it.amount;
            });
            this.rates.unitPriceSummary = response.data.data.unitPriceSummary;
            this.rates.shoppingCartSummary = response.data.data.shoppingCartSummary;
            this.rates.policies = response.data.data.policies;
          }
          this.rates.rates.forEach((it) => {
            if (isNil(it.customAmount)) it.customAmount = it.amount;
          });
        });
    },
    updatePaymentStatus: function () {
      return this.axios
        .get(this.serviceUrls.reservation.paymentStatus(this, this.reservationId))
        .then((response) => {
          this.paymentStatus = Object.freeze(response.data.data);
        })
        .finally(() => {
          this.debounceUpdateFolios();
        })
        .finally(() => {
          this.loadedPage.reservationPaymentStatus = true;
        });
    },
    onUpdateNumChildren: function () {
      const children = this.intArray(this.reservation.stayDetails.numChildren, 1);
      const defaultAgeCategoryId = isNil(this.hotelSettings.ageCategories.all()
        .find(it => it.ageQualifier !== 'Adult'))
        ? this.hotelSettings.ageCategories.all()
          .find(it => it.ageQualifier === 'Adult').id
        : this.hotelSettings.ageCategories.all()
          .find(it => it.ageQualifier !== 'Adult').id;
      children.forEach((it) => {
        if (isEmpty(get(this.reservation.stayDetails.childAgeCategories, it, null))) {
          this.reservation.stayDetails.childAgeCategories[it] = defaultAgeCategoryId;
        }
      });
    },
    evaluate: function (expression) {
      // eslint-disable-next-line no-useless-escape
      return isEmpty(expression) ? true : (/true/i).test(template(`$\{${expression}\}`)(
        {
          canEdit: this.canEdit,
          reservation: this.reservation,
          rates: this.rates,
          isLocked: this.isLocked,
          hasLicense: this.hasLicense,
          hasRole: this.hasRole,
          $shortLocale: this.$shortLocale,
        },
      ));
    },
    onClickFloatingButton: function (actionId) {
      // eslint-disable-next-line no-underscore-dangle
      this.as__autosave();
      this.$store.commit('save/started', this.reservationId);
      this.axios.post(this.serviceUrls.reservation.action(this, this.reservationId, actionId))
        .then((response) => {
          this.$store.commit('save/finished', this.reservationId);

          this.showSuccessMessage();
          this.showMessages(response);

          // eslint-disable-next-line no-underscore-dangle
          this.as__pauseAutosave('reservation');
          this.updateReservation()
            .then((innerResponse) => {
              this.showMessages(innerResponse);
              // eslint-disable-next-line no-underscore-dangle
              this.as__continueAutosave('reservation');
            })
            .catch((error) => {
              this.showMessages(error.response);
            });

          // eslint-disable-next-line no-underscore-dangle
          this.as__pauseAutosave('rates');
          this.updateReservationRates()
            .then((innerResponse) => {
              this.showMessages(innerResponse);
              // eslint-disable-next-line no-underscore-dangle
              this.as__continueAutosave('rates');
            })
            .catch((error) => {
              this.showMessages(error.response);
            });

          this.updatePaymentStatus()
            .then((innerResponse) => {
              this.showMessages(innerResponse);
            })
            .catch((error) => {
              this.showMessages(error.response);
            });
          this.updateRoomChargeInvoiceRecipientPaymentStatus()
            .then((innerResponse) => {
              this.showMessages(innerResponse);
            })
            .catch((error) => {
              this.showMessages(error.response);
            });
          this.debounceUpdateGuestPaymentStatus();
        })
        .catch((error) => {
          this.$store.commit('save/finished', this.reservationId);
          this.showMessages(error.response);
        });
    },
    onChangeShoppingCartItemId: function () {
      const obj = isEmpty(this.newShoppingCartItem.inHouseServiceId) ? null : this.findHotelSettingById('inHouseServices', this.newShoppingCartItem.inHouseServiceId);
      if (isEmpty(obj)) {
        this.newShoppingCartItem.itemPrice = 0.0;
        this.newShoppingCartItem.itemCount = 1.0;
        this.newShoppingCartItem.inHouseService = null;
        this.newShoppingCartItem.alternativeLabel = null;
        this.newShoppingCartItem.date = null;
      } else {
        this.newShoppingCartItem.itemPrice = obj.amount;
        this.newShoppingCartItem.itemCount = 1.0;
        this.newShoppingCartItem.inHouseService = obj;
        this.newShoppingCartItem.alternativeLabel = null;
        this.newShoppingCartItem.date = obj.rateMode === 'PerRoom' && obj.rateFrequency === 'PerStay' ? (this.newShoppingCartItem.date || this.reservation.checkOutDate) : null;
      }
    },
    addShoppingCartItem: function () {
      if (isNil(this.newShoppingCartItem.inHouseServiceId)) {
        return;
      }
      if (isNil(this.newShoppingCartItem.itemCount === 0)) {
        return;
      }
      if (!isNil(this.rates)) {
        if (isNil(this.rates.shoppingCart)) {
          this.rates.shoppingCart = [this.newShoppingCartItem];
        } else {
          if (this.rates.shoppingCart.filter(it => it.inHouseServiceId === this.newShoppingCartItem.inHouseServiceId).length > 0) {
            // this.showWarningMessage('Diese Zusatzleistung wurde zuvor bereits mind. 1 mal hinzugefügt.');
          }
          this.rates.shoppingCart.push(this.newShoppingCartItem);
        }

        // this.debouncedUpdateRates();

        this.newShoppingCartItem = {
          id: uuid.v4(),
          inHouseServiceId: null,
          itemPrice: 0.0,
          itemCount: 1.0,
          alternativeLabel: null,
          date: null,
        };
      }

      this.showAddTransactionModal = false;
    },
    updatePaymentCharts() {
      if (!isNil(this.$refs.reservationPaymentStatus)) this.$refs.reservationPaymentStatus.updateChart();
      if (!isNil(this.$refs.guestPaymentStatus)) this.$refs.guestPaymentStatus.updateChart();
      if (!isNil(this.$refs.companyPaymentStatus)) this.$refs.companyPaymentStatus.updateChart();
      if (!isNil(this.$refs.billingContactPaymentStatus)) this.$refs.billingContactPaymentStatus.updateChart();
      if (!isNil(this.$refs.roomChargeInvoiceRecipientPaymentStatus2)) this.$refs.roomChargeInvoiceRecipientPaymentStatus2.updateChart();
    },
    id2number: function (value) {
      if (isEmpty(value)) return '';
      return last(value.split('::'));
    },
    openStripeCustomer(stripeCustomerToken) {
      if (document.querySelector('body.production')) {
        window.open(`https://dashboard.stripe.com/customers/${stripeCustomerToken}`, '_blank');
      } else {
        window.open(`https://dashboard.stripe.com/test/customers/${stripeCustomerToken}`, '_blank');
      }
    },
    createDepositPaymentRequest() {
      this.paymentRequestsWizardActive = true;
    },
    closePaymentRequestWizard() {
      this.paymentRequestsWizardActive = false;
      this.setTimeout(this.updatePaymentRequests, 500);
      this.setTimeout(() => { this.debounceUpdateCorrespondence(); }, 1000);
    },
    updateKeys(i = 0) {
      if (this.keyChangeCounter > 0 && this.keyRefreshCounter > 15) return;
      if (this.keyChangeCounter === 0 && this.keyRefreshCounter > 1) return;
      this.keyRefreshCounter++;
      if (this.hasAnyLicense(['InterfaceLoxone', 'InterfaceSeam', 'InterfaceCharPmsLink'])) {
        this.updatingKeys = true;
        this.axios.get(this.serviceUrls.reservation.key.get(this, this.reservationId))
          .then((response) => {
            this.reservation.stayDetails.roomKeys = response.data.data;
          })
          .finally(() => {
            this.updatingKeys = false;
          });
      }
    },
    revokeKey(keyId) {
      const key = find(this.reservation.stayDetails.roomKeys, it => it.id === keyId);
      if (!isEmpty(key)) {
        if (!isEmpty(this.hotelSettings.interfaces.hotelKeyManagementConfiguration)
          && !isEmpty(this.hotelSettings.interfaces.hotelKeyManagementConfiguration[key.keyManagementConfigurationId])
        ) {
          const config = this.hotelSettings.interfaces.hotelKeyManagementConfiguration[key.keyManagementConfigurationId];
          if (key.keyType === 'KeyCard' && config.lockingSystem === 'CharPmsLink') {
            this.showConfirmModal(
              this.$t('pageRoomReservation.confirmCardIsNotDeletedFromLockingSystem'),
              (doNotShowAgain) => {
                this._revokeKey(keyId);
              },
              null,
              {
                timer: '-',
              },
            );
            return;
          }
        }
      }

      this._revokeKey(keyId);
    },
    _revokeKey(keyId) {
      this.updatingKeys = true;
      this.axios.delete(this.serviceUrls.reservation.key.delete(this, this.reservationId, keyId))
        .then((response) => {
          this.showSuccessMessage();
          this.reservation.stayDetails.roomKeys = response.data.data;
          this.debounceUpdateCorrespondence();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.updatingKeys = false;
          this.keyChangeCounter++;
        });
    },
    addKey() {
      this.updatingKeys = true;
      this.axios.post(this.serviceUrls.reservation.key.get(this, this.reservationId))
        .then((response) => {
          this.showSuccessMessage();
          this.reservation.stayDetails.roomKeys = response.data.data;
          this.debounceUpdateCorrespondence();
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .finally(() => {
          this.updatingKeys = false;
          this.keyChangeCounter++;
        });
    },
    addKeyCard() {
      const hkm = this.hotelSettings.interfaces.hotelKeyManagementConfiguration;
      const kcConfigurations = Object.entries(hkm)
        .filter(it => it[0] !== 'rooms' && ['CharPmsLink'].includes(it[1].lockingSystem) && it[1].keyType === 'KeyCard')
        .map(it => it[1]);

      const kcConfigIds = map(kcConfigurations, 'id');
      const kcRooms = Object.values(hkm.rooms)
        .filter(it => kcConfigIds.includes(it.keyManagementConfigurationId));
      const kcRoomNumbers = map(kcRooms, 'roomNumber');

      if (!kcRoomNumbers.includes(this.reservation.stayDetails.roomNumber)) {
        this.showErrorMessage('This room does not support key cards.');
        return;
      }

      const kcRoom = kcRooms.find(it => it.roomNumber === this.reservation.stayDetails.roomNumber);
      const kcConfig = kcConfigurations.find(it => it.id === kcRoom.keyManagementConfigurationId);

      if (isNil(kcRoom) || isNil(kcConfig)) {
        this.showErrorMessage('Invalid key card configuration.');
        return;
      }

      if (!kcConfig.enabled || !kcRoom.enabled) {
        this.showErrorMessage('Key Management Configuration disabled');
        return;
      }

      if (!kcConfig.cfgCharPmsLink.enabled) {
        this.showErrorMessage('char pmslink disabled');
        return;
      }

      this.charPmsLinkKeyCard.enabled = kcConfig.enabled;
      this.charPmsLinkKeyCard.keyCardEnabled = kcConfig.cfgCharPmsLink.enabled;
      this.charPmsLinkKeyCard.mobileKeyEnabled = kcConfig.cfgCharPmsLink.mobileKeyEnabled;
      this.charPmsLinkKeyCard.encoders = kcConfig.cfgCharPmsLink.encoders;
      this.charPmsLinkKeyCard.extraAccess = kcConfig.cfgCharPmsLink.extraAccess;
      this.charPmsLinkKeyCard.encoderWaitSeconds = kcConfig.cfgCharPmsLink.encoderWaitSeconds;
      this.charPmsLinkKeyCard.rooms = kcRooms.filter(it => it.keyManagementConfigurationId === kcConfig.id).map(it => it.roomNumber);
      this.charPmsLinkKeyCard.key.keyManagementConfigurationId = kcConfig.id;
      this.charPmsLinkKeyCard.key.charPmsLinkConfigId = kcConfig.cfgCharPmsLink.configId;
      this.charPmsLinkKeyCard.key.roomNumber = kcRoom.roomNumber;
      this.charPmsLinkKeyCard.key.extraAccess = [];
      this.charPmsLinkKeyCard.key.encoder = null;
      this.charPmsLinkKeyCard.key.numberOfCards = kcConfig.cfgCharPmsLink.numberOfCards;
      this.charPmsLinkKeyCard.key.arrivalDate = this.reservation.checkInDate;
      this.charPmsLinkKeyCard.key.arrivalTime = this.reservation.stayDetails.arrivalTime || this.hotelSettings.details.checkInTime;
      this.charPmsLinkKeyCard.key.departureDate = this.reservation.checkOutDate;
      this.charPmsLinkKeyCard.key.departureTime = this.reservation.stayDetails.departureTime || this.hotelSettings.details.checkOutTime;

      if (this.reservation.status === 'InHouse') {
        const now = new Date();
        this.charPmsLinkKeyCard.key.arrivalDate = this.$moment(now).format('YYYYMMDD');
        this.charPmsLinkKeyCard.key.arrivalTime = `${now.getHours()}:${Math.floor(now.getMinutes() / 15) * 15}`;
      }

      this.showCharPmsLinkKeyCardModal = true;
    },
    crateSeamGrant() {
      this.axios.post(this.serviceUrls.reservation.key.seam.grant(this, this.reservationId), { roomNumber: this.reservation.stayDetails.roomNumber })
        .then((_) => {
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.updateKeys();
        })
        .finally(() => {
          this.keyChangeCounter++;
        });
    },
    createCharPmsLinkKeyCard() {
      const keyCard = cloneDeep(this.charPmsLinkKeyCard.key);
      this.charPmsLinkStatus = this.charPmsLinkKeyCard.encoderWaitSeconds || 20;
      const $vm = this;
      const interval = this.setInterval(() => {
        if (isNumber(this.charPmsLinkStatus) && this.charPmsLinkStatus > 0) {
          this.charPmsLinkStatus--;
        } else {
          $vm.clearInterval(interval);
        }
      }, 1000);
      this.axios.post(this.serviceUrls.reservation.key.card(this, this.reservationId), keyCard)
        .then((_) => {
          const msg = this.$t('MessageStatus.Success');
          this.charPmsLinkStatus = msg;
          this.showSuccessMessage();
          this.updateKeys();
          this.showCharPmsLinkKeyCardModal = false;
          this.setTimeout(() => {
            if (this.charPmsLinkStatus === msg) {
              this.charPmsLinkStatus = null;
            }
          }, 4000);
        })
        .catch((error) => {
          this.showMessages(error.response);
          try {
            this.charPmsLinkStatus = error.response.data.errors[0].title + ' ' + error.response.data.errors[0].message;
          } catch (ex) {
            console.error(ex);
            this.charPmsLinkStatus = $t('pageRoomReservation.charPmsLinkKeyCard.unknownError');
          }
          const err = this.charPmsLinkStatus;
          this.setTimeout(() => {
            if (this.charPmsLinkStatus === err) {
              this.charPmsLinkStatus = null;
            }
          }, 5000);
        })
        .finally(() => {
          this.keyChangeCounter++;
          this.clearInterval(interval);
        });
    },
    getKeyTitle(key) {
      let title = key.code || key.externalId || key.id;
      let config = null;

      try {
        config = this.hotelSettings.interfaces.hotelKeyManagementConfiguration[key.keyManagementConfigurationId];
        if (['SeamLocks', 'SeamLocksAcs'].includes(config.lockingSystem) && isEmpty(key.code)) {
          return this.$t('pageRoomReservation.locking.creating');
        }
      } catch (e) { /* ignore */ }

      let roomLabel = null;
      let roomConfig = null;
      try {
        roomConfig = this.hotelSettings.interfaces.hotelKeyManagementConfiguration.rooms[key.roomNumber];
        roomLabel = ((roomConfig || {}).roomLabel);
      } catch (e) { /* ignore */ }

      if (!isNil(config) && config.lockingSystem === 'CharPmsLink') {
        title = '';
        if (!isEmpty(key.additionalFields) && !isEmpty(key.additionalFields.CARDS)) {
          title = `${key.additionalFields.CARDS} x `;
        }
        title += key.name || '-';
      }

      if (!isEmpty(key.roomNumber)) title += ` // ${roomLabel || key.roomNumber}`;

      if (!isNil(config) && config.lockingSystem === 'CharPmsLink') {
        if (!isNil(roomConfig) && !isEmpty(roomConfig.externalRoomNumber) && roomConfig.externalRoomNumber !== key.roomNumber) {
          title += ` (${roomConfig.externalRoomNumber})`;
        }
        if (!isEmpty(key.additionalFields) && !isEmpty(key.additionalFields.EXTRA_ACCESS)) {
          title += ` + ${key.additionalFields.EXTRA_ACCESS}`;
        }
      }

      if (key.additionalAccessKey) title = `<i class="fal fa-link" style="padding-right:6px;"></i> ${title}`;

      return title;
    },
    onClickKey(key) {
      if (!isEmpty(key.additionalFields) && !isEmpty(key.additionalFields.SEAM_DEVICE_ID) && !isEmpty(key.keyManagementConfigurationId)) {
        this.axios.get(this.serviceUrls.interfaces.locking.seam.session(this, key.keyManagementConfigurationId))
          .then((response) => {
            this.seamAccessToken = response.data.data.token;
            this.showSeamKeyDetail = true;
            this.seamKey = key;
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          });
      }
    },
    retrieveReservation(managedBy, reservation) {
      switch (managedBy) {
        case 'ConnectCX': {
          let defaultConnectCxId = null;
          try {
            defaultConnectCxId = first(map(this.hotelSettings.interfaces.connectCx, 'id'));
          } catch (ignore) { /* ignore */ }
          const configId = reservation.additionalFields.ConnectCX_config || defaultConnectCxId || 'null';
          const bookingId = reservation.additionalFields.ConnectCX_booking || find(reservation.externalReservationNumbers, o => o.key === 'Connect.CX Booking ID').value || '';
          if (isEmpty(bookingId)) {
            this.showErrorMessage();
            break;
          }
          this.axios.post(this.serviceUrls.interfaces.channelManagerCx.reservation(this, configId, bookingId))
            .then((response) => {
              this.updateReservation();
              this.updateCorrespondence();
              this.showSuccessMessage();
            })
            .catch((error) => {
              if (isNil(error.response)) this.showErrorMessage();
              this.showMessages(error.response);
            });
          break;
        }
        case 'HotelSpider': {
          const bookingId = find(reservation.externalReservationNumbers, o => o.key === 'Hotel-Spider' || o.key === 'Hotel-Spider Staging').value || '';
          if (isEmpty(bookingId)) {
            this.showErrorMessage();
            break;
          }
          this.axios.post(this.serviceUrls.interfaces.hotelSpider.retrieveReservation(this, 'null', bookingId))
            .then((response) => {
              this.updateReservation();
              this.updateCorrespondence();
              this.showSuccessMessage();
            })
            .catch((error) => {
              if (isNil(error.response)) this.showErrorMessage();
              this.showMessages(error.response);
            });
          break;
        }
        default:
          this.showErrorMessage();
          break;
      }
    },
    resendToSmartpricing() {
      if (this.hasLicense('InterfaceSmartpricing') && !isNil(this.hotelSettings.interfaces) && !isNil(this.hotelSettings.interfaces.smartpricing) && this.hotelSettings.interfaces.smartpricing.enabled === true) {
        const interfaceId = this.hotelSettings.interfaces.smartpricing;
        this.axios.post(this.serviceUrls.interfaces.smartpricing.sendReservation(this, interfaceId, this.reservationId))
          .then((response) => {
            this.showSuccessMessage();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          });
      }
    },
    env: function (name) {
      return process.env[name];
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
@import '~styles/import';

.countdown {
  font-weight: 700;
  font-size: 3rem;
  line-height: 4.5rem;
  text-align: center;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/PageRoomReservation.vue